/* Translation of en-US.ts. Same keys, in the same order; only the
 * values are translated, and every {{placeholder}} is kept. */
export const notifications = {
  "types": {
    "feature_request_update": {
      "status": {
        "title": "Ihr Funktionswunsch ist {{featureStatus}}",
        "body": "„{{request}}“ ist {{featureStatus}}."
      },
      "reply": {
        "title": "Antwort auf Ihren Funktionswunsch",
        "body": "„{{request}}“: {{reply}}"
      },
      "merged": {
        "title": "Bereits gewünscht",
        "body": "„{{request}}“ wurde bereits gewünscht. Wir haben Ihre Stimme hinzugefügt."
      }
    },
    "feature_idea_update": {
      "default": {
        "title": "Eine Idee, für die Sie gestimmt haben, ist {{featureStatus}}",
        "body": "„{{idea}}“ ist {{featureStatus}}."
      }
    },
    "work_change_opened": {
      "default": {
        "title": "Der Auftrag wird geändert",
        "body": "{{actor}} ändert „{{job}}“. Sie werden gebeten, ihn erneut anzunehmen."
      }
    },
    "work_changed": {
      "default": {
        "title": "Der Auftrag hat sich geändert. Nehmen Sie ihn erneut an",
        "body": "{{actor}} hat „{{job}}“ geändert: {{changes}}. Prüfen Sie ihn und nehmen Sie ihn erneut an."
      }
    },
    "quote_scope_changed": {
      "default": {
        "title": "Der Umfang Ihres Angebots hat sich geändert",
        "body": "{{actor}} hat „{{job}}“ geändert: {{changes}}. Bieten Sie erneut auf den neuen Umfang."
      }
    },
    "work_accepted_longer": {
      "default": {
        "title": "Angenommen, und es dauert jetzt länger",
        "body": "{{actor}} hat „{{job}}“ angenommen und braucht jetzt {{minutes}} Minuten. Prüfen Sie den Fälligkeitstermin."
      }
    },
    "quote_accepted": {
      "noJob": {
        "title": "Ihr Angebot wurde angenommen",
        "body": "Ihr Angebot für einen Auftrag wurde angenommen. Die Arbeit gehört Ihnen."
      },
      "default": {
        "title": "Ihr Angebot wurde angenommen",
        "body": "Ihr Angebot für „{{job}}“ wurde angenommen. Die Arbeit gehört Ihnen."
      }
    },
    "asset_request_job_assigned": {
      "noActor": {
        "title": "Arbeit zugewiesen",
        "body": "Das Team hat den Auftrag zu {{request}} an {{assignee}} übergeben."
      },
      "default": {
        "title": "Arbeit zugewiesen",
        "body": "{{actor}} hat den Auftrag zu {{request}} an {{assignee}} übergeben."
      }
    },
    "asset_request_job_accepted": {
      "noActor": {
        "title": "Auftrag angenommen",
        "body": "Das Team hat den Auftrag zu {{request}} angenommen."
      },
      "default": {
        "title": "Auftrag angenommen",
        "body": "{{actor}} hat den Auftrag zu {{request}} angenommen."
      }
    },
    "asset_request_job_declined": {
      "noActor": {
        "title": "Auftrag abgelehnt",
        "body": "Das Team kann den Auftrag zu {{request}} nicht übernehmen. Das Team sucht jemand anderen."
      },
      "default": {
        "title": "Auftrag abgelehnt",
        "body": "{{actor}} kann den Auftrag zu {{request}} nicht übernehmen. Das Team sucht jemand anderen."
      }
    },
    "asset_request_job_verified": {
      "noActor": {
        "title": "Arbeit verifiziert",
        "body": "Das Team hat die erledigte Arbeit zu {{request}} verifiziert."
      },
      "default": {
        "title": "Arbeit verifiziert",
        "body": "{{actor}} hat die erledigte Arbeit zu {{request}} verifiziert."
      }
    },
    "asset_request_inspection_approved": {
      "noActor": {
        "title": "Inspektion abgenommen",
        "body": "Das Team hat die Inspektion zu {{request}} abgenommen."
      },
      "default": {
        "title": "Inspektion abgenommen",
        "body": "{{actor}} hat die Inspektion zu {{request}} abgenommen."
      }
    },
    "asset_request_submitted": {
      "noActor": {
        "title": "Eine Anfrage für Sie",
        "body": "Das Team hat „{{request}}“ für Sie an {{asset}} gestellt."
      },
      "default": {
        "title": "Eine Anfrage für Sie",
        "body": "{{actor}} hat „{{request}}“ für Sie an {{asset}} gestellt."
      }
    },
    "job_started": {
      "noActor": {
        "title": "Auftrag begonnen",
        "body": "Die zugewiesene Person hat „{{job}}“ begonnen."
      },
      "default": {
        "title": "Auftrag begonnen",
        "body": "{{actor}} hat „{{job}}“ begonnen."
      }
    },
    "job_paused": {
      "noActorReason": {
        "title": "Auftrag pausiert",
        "body": "Die zugewiesene Person hat „{{job}}“ pausiert. {{reason}}"
      },
      "noActor": {
        "title": "Auftrag pausiert",
        "body": "Die zugewiesene Person hat „{{job}}“ pausiert."
      },
      "reason": {
        "title": "Auftrag pausiert",
        "body": "{{actor}} hat „{{job}}“ pausiert. {{reason}}"
      },
      "default": {
        "title": "Auftrag pausiert",
        "body": "{{actor}} hat „{{job}}“ pausiert."
      }
    },
    "job_resumed": {
      "noActor": {
        "title": "Auftrag fortgesetzt",
        "body": "Die zugewiesene Person hat „{{job}}“ fortgesetzt."
      },
      "default": {
        "title": "Auftrag fortgesetzt",
        "body": "{{actor}} hat „{{job}}“ fortgesetzt."
      }
    },
    "job_evidence_added": {
      "noActor": {
        "title": "Nachweise ergänzt",
        "body": "Die zugewiesene Person hat die angeforderten Nachweise zu „{{job}}“ ergänzt. Prüfen Sie sie, um den Auftrag abzuschließen."
      },
      "default": {
        "title": "Nachweise ergänzt",
        "body": "{{actor}} hat die angeforderten Nachweise zu „{{job}}“ ergänzt. Prüfen Sie sie, um den Auftrag abzuschließen."
      }
    },
    "inspection_cancelled": {
      "noActorNoAssetReason": {
        "title": "Inspektion abgebrochen",
        "body": "Eine Kollegin oder ein Kollege hat die Inspektion an einer Anlage abgebrochen. {{reason}}"
      },
      "noActorNoAsset": {
        "title": "Inspektion abgebrochen",
        "body": "Eine Kollegin oder ein Kollege hat die Inspektion an einer Anlage abgebrochen."
      },
      "noActorReason": {
        "title": "Inspektion abgebrochen",
        "body": "Eine Kollegin oder ein Kollege hat die Inspektion an {{asset}} abgebrochen. {{reason}}"
      },
      "noActor": {
        "title": "Inspektion abgebrochen",
        "body": "Eine Kollegin oder ein Kollege hat die Inspektion an {{asset}} abgebrochen."
      },
      "reason": {
        "title": "Inspektion abgebrochen",
        "body": "{{actor}} hat die Inspektion an {{asset}} abgebrochen. {{reason}}"
      },
      "default": {
        "title": "Inspektion abgebrochen",
        "body": "{{actor}} hat die Inspektion an {{asset}} abgebrochen."
      }
    },
    "asset_collaboration_shared": {
      "noAsset": {
        "title": "Eine Anlage wurde mit Ihnen geteilt",
        "body": "Anlage – öffnen Sie sie, um den Zugriff zu prüfen und anzunehmen."
      },
      "default": {
        "title": "Eine Anlage wurde mit Ihnen geteilt",
        "body": "{{asset}} – öffnen Sie sie, um den Zugriff zu prüfen und anzunehmen."
      }
    },
    "asset_in_service": {
      "backNoAsset": {
        "title": "Anlage wieder in Betrieb",
        "body": "Eine Anlage ist in Betrieb. Die Zeitpläne laufen ab heute weiter. {{note}}"
      },
      "backNoAssetNoNote": {
        "title": "Anlage wieder in Betrieb",
        "body": "Eine Anlage ist in Betrieb. Die Zeitpläne laufen ab heute weiter."
      },
      "firstNoAsset": {
        "title": "Anlage in Betrieb",
        "body": "Eine Anlage ist in Betrieb. Die Zeitpläne laufen ab heute weiter. {{note}}"
      },
      "firstNoAssetNoNote": {
        "title": "Anlage in Betrieb",
        "body": "Eine Anlage ist in Betrieb. Die Zeitpläne laufen ab heute weiter."
      },
      "back": {
        "title": "Anlage wieder in Betrieb",
        "body": "{{asset}} ist in Betrieb. Die Zeitpläne laufen ab heute weiter. {{note}}"
      },
      "backNoNote": {
        "title": "Anlage wieder in Betrieb",
        "body": "{{asset}} ist in Betrieb. Die Zeitpläne laufen ab heute weiter."
      },
      "first": {
        "title": "Anlage in Betrieb",
        "body": "{{asset}} ist in Betrieb. Die Zeitpläne laufen ab heute weiter. {{note}}"
      },
      "firstNoNote": {
        "title": "Anlage in Betrieb",
        "body": "{{asset}} ist in Betrieb. Die Zeitpläne laufen ab heute weiter."
      }
    },
    "asset_out_of_service": {
      "noAsset": {
        "title": "Anlage außer Betrieb",
        "body": "Eine Anlage ist außer Betrieb ({{reason}}). Die Zeitpläne der Anlage sind bis zur Wiederinbetriebnahme pausiert. {{note}}"
      },
      "noAssetNoNote": {
        "title": "Anlage außer Betrieb",
        "body": "Eine Anlage ist außer Betrieb ({{reason}}). Die Zeitpläne der Anlage sind bis zur Wiederinbetriebnahme pausiert."
      },
      "noAssetNoReason": {
        "title": "Anlage außer Betrieb",
        "body": "Eine Anlage ist außer Betrieb. Die Zeitpläne der Anlage sind bis zur Wiederinbetriebnahme pausiert. {{note}}"
      },
      "noAssetNoReasonNoNote": {
        "title": "Anlage außer Betrieb",
        "body": "Eine Anlage ist außer Betrieb. Die Zeitpläne der Anlage sind bis zur Wiederinbetriebnahme pausiert."
      },
      "default": {
        "title": "Anlage außer Betrieb",
        "body": "{{asset}} ist außer Betrieb ({{reason}}). Die Zeitpläne der Anlage sind bis zur Wiederinbetriebnahme pausiert. {{note}}"
      },
      "noNote": {
        "title": "Anlage außer Betrieb",
        "body": "{{asset}} ist außer Betrieb ({{reason}}). Die Zeitpläne der Anlage sind bis zur Wiederinbetriebnahme pausiert."
      },
      "noReason": {
        "title": "Anlage außer Betrieb",
        "body": "{{asset}} ist außer Betrieb. Die Zeitpläne der Anlage sind bis zur Wiederinbetriebnahme pausiert. {{note}}"
      },
      "noReasonNoNote": {
        "title": "Anlage außer Betrieb",
        "body": "{{asset}} ist außer Betrieb. Die Zeitpläne der Anlage sind bis zur Wiederinbetriebnahme pausiert."
      }
    },
    "asset_owner_assigned": {
      "default": {
        "title": "Neue Anlagenverantwortung",
        "body": "{{asset}} liegt jetzt in Ihrer Verantwortung."
      }
    },
    "asset_owner_removed": {
      "default": {
        "title": "Anlagenverantwortung geändert",
        "body": "{{asset}} liegt nicht mehr in Ihrer Verantwortung."
      }
    },
    "asset_request_approved": {
      "noAsset": {
        "title": "Ihre Anfrage wurde genehmigt",
        "body": "„{{request}}“ wurde für die Anlage genehmigt."
      },
      "default": {
        "title": "Ihre Anfrage wurde genehmigt",
        "body": "„{{request}}“ wurde für {{asset}} genehmigt."
      },
      "withNote": {
        "title": "Ihre Anfrage wurde genehmigt",
        "body": "„{{request}}“ wurde genehmigt: {{note}}"
      }
    },
    "asset_request_awaiting_customer": {
      "noAsset": {
        "title": "Handlungsbedarf bei Ihrer Anfrage",
        "body": "{{request}} wartet auf eine Antwort von Ihnen zur Anlage."
      },
      "default": {
        "title": "Handlungsbedarf bei Ihrer Anfrage",
        "body": "{{request}} wartet auf eine Antwort von Ihnen zu {{asset}}."
      },
      "note": {
        "title": "Handlungsbedarf bei Ihrer Anfrage",
        "body": "{{note}}"
      }
    },
    "asset_request_closed": {
      "byActor": {
        "title": "Vorgang abgeschlossen – alle Arbeiten erledigt",
        "body": "{{actor}} hat die letzten Arbeiten zu {{request}} verifiziert. Alles wurde erledigt und abgenommen."
      },
      "default": {
        "title": "Vorgang abgeschlossen – alle Arbeiten erledigt",
        "body": "{{request}}: Alles wurde erledigt und abgenommen. Es ist nichts mehr zu tun."
      },
      "operatorClosed": {
        "title": "Ihre Anfrage wurde geschlossen",
        "body": "{{request}} wurde als erledigt markiert."
      }
    },
    "asset_request_commented": {
      "requesterNoRequestPhotoLegacy": {
        "title": "Neue Nachricht",
        "body": "Die anfragende Person hat zu einer Anfrage ein Foto geteilt."
      },
      "requesterNoRequestPhoto": {
        "title": "Neue Nachricht",
        "body": "Die anfragende Person hat zu einer Anfrage ein Foto geteilt."
      },
      "teamNoRequestPhotoLegacy": {
        "title": "Neue Nachricht",
        "body": "Das Team hat zu einer Anfrage ein Foto geteilt."
      },
      "teamNoRequestPhoto": {
        "title": "Neue Nachricht",
        "body": "Das Team hat zu einer Anfrage ein Foto geteilt."
      },
      "requesterPhoto": {
        "title": "Neue Nachricht",
        "body": "Die anfragende Person hat zu „{{request}}“ ein Foto geteilt."
      },
      "noRequestPhotoLegacy": {
        "title": "Neue Nachricht",
        "body": "{{author}} hat zu einer Anfrage ein Foto geteilt."
      },
      "noRequestPhoto": {
        "title": "Neue Nachricht",
        "body": "{{author}} hat zu einer Anfrage ein Foto geteilt."
      },
      "teamPhoto": {
        "title": "Neue Nachricht",
        "body": "Das Team hat zu „{{request}}“ ein Foto geteilt."
      },
      "requesterNoRequestLegacy": {
        "title": "Neue Nachricht",
        "body": "Die anfragende Person zu einer Anfrage: {{message}}"
      },
      "requesterNoRequest": {
        "title": "Neue Nachricht",
        "body": "Die anfragende Person zu einer Anfrage: {{message}}"
      },
      "teamNoRequestLegacy": {
        "title": "Neue Nachricht",
        "body": "Das Team zu einer Anfrage: {{message}}"
      },
      "teamNoRequest": {
        "title": "Neue Nachricht",
        "body": "Das Team zu einer Anfrage: {{message}}"
      },
      "photo": {
        "title": "Neue Nachricht",
        "body": "{{author}} hat zu „{{request}}“ ein Foto geteilt."
      },
      "requester": {
        "title": "Neue Nachricht",
        "body": "Die anfragende Person zu „{{request}}“: {{message}}"
      },
      "noRequestLegacy": {
        "title": "Neue Nachricht",
        "body": "{{author}} zu einer Anfrage: {{message}}"
      },
      "noRequest": {
        "title": "Neue Nachricht",
        "body": "{{author}} zu einer Anfrage: {{message}}"
      },
      "team": {
        "title": "Neue Nachricht",
        "body": "Das Team zu „{{request}}“: {{message}}"
      },
      "default": {
        "title": "Neue Nachricht",
        "body": "{{author}} zu „{{request}}“: {{message}}"
      }
    },
    "asset_request_completion_accepted": {
      "verifierNoRequesterNoRequestLegacy": {
        "title": "Die anfragende Person ist zufrieden – zum Schließen verifizieren",
        "body": "Die anfragende Person hat die abgeschlossenen Arbeiten zur Anfrage angenommen. Verifizieren Sie den Auftrag, um ihn zu schließen."
      },
      "verifierNoRequesterNoRequest": {
        "title": "Die anfragende Person ist zufrieden – zum Schließen verifizieren",
        "body": "Die anfragende Person hat die abgeschlossenen Arbeiten zur Anfrage angenommen. Verifizieren Sie den Auftrag, um ihn zu schließen."
      },
      "verifierNoRequester": {
        "title": "Die anfragende Person ist zufrieden – zum Schließen verifizieren",
        "body": "Die anfragende Person hat die abgeschlossenen Arbeiten zu „{{request}}“ angenommen. Verifizieren Sie den Auftrag, um ihn zu schließen."
      },
      "verifierNoRequestLegacy": {
        "title": "Die anfragende Person ist zufrieden – zum Schließen verifizieren",
        "body": "{{requester}} hat die abgeschlossenen Arbeiten zur Anfrage angenommen. Verifizieren Sie den Auftrag, um ihn zu schließen."
      },
      "verifierNoRequest": {
        "title": "Die anfragende Person ist zufrieden – zum Schließen verifizieren",
        "body": "{{requester}} hat die abgeschlossenen Arbeiten zur Anfrage angenommen. Verifizieren Sie den Auftrag, um ihn zu schließen."
      },
      "verifier": {
        "title": "Die anfragende Person ist zufrieden – zum Schließen verifizieren",
        "body": "{{requester}} hat die abgeschlossenen Arbeiten zu „{{request}}“ angenommen. Verifizieren Sie den Auftrag, um ihn zu schließen."
      },
      "informedNoRequesterNoRequestLegacy": {
        "title": "Die anfragende Person hat die Arbeiten angenommen",
        "body": "Die anfragende Person hat die abgeschlossenen Arbeiten zur Anfrage angenommen."
      },
      "informedNoRequesterNoRequest": {
        "title": "Die anfragende Person hat die Arbeiten angenommen",
        "body": "Die anfragende Person hat die abgeschlossenen Arbeiten zur Anfrage angenommen."
      },
      "informedNoRequester": {
        "title": "Die anfragende Person hat die Arbeiten angenommen",
        "body": "Die anfragende Person hat die abgeschlossenen Arbeiten zu „{{request}}“ angenommen."
      },
      "informedNoRequestLegacy": {
        "title": "Die anfragende Person hat die Arbeiten angenommen",
        "body": "{{requester}} hat die abgeschlossenen Arbeiten zur Anfrage angenommen."
      },
      "informedNoRequest": {
        "title": "Die anfragende Person hat die Arbeiten angenommen",
        "body": "{{requester}} hat die abgeschlossenen Arbeiten zur Anfrage angenommen."
      },
      "informed": {
        "title": "Die anfragende Person hat die Arbeiten angenommen",
        "body": "{{requester}} hat die abgeschlossenen Arbeiten zu „{{request}}“ angenommen."
      }
    },
    "asset_request_completion_rejected": {
      "noActor": {
        "title": "Abschluss abgelehnt",
        "body": "Das Team hat die abgeschlossenen Arbeiten zu {{request}} abgelehnt. {{note}}"
      },
      "noActorNoNote": {
        "title": "Abschluss abgelehnt",
        "body": "Das Team hat die abgeschlossenen Arbeiten zu {{request}} abgelehnt."
      },
      "default": {
        "title": "Abschluss abgelehnt",
        "body": "{{actor}} hat die abgeschlossenen Arbeiten zu {{request}} abgelehnt. {{note}}"
      },
      "noNote": {
        "title": "Abschluss abgelehnt",
        "body": "{{actor}} hat die abgeschlossenen Arbeiten zu {{request}} abgelehnt."
      }
    },
    "asset_request_confirmed_schedule": {
      "requestNoRequest": {
        "title": "Termin bestätigt",
        "body": "Anfrage – die anfragende Person hat den geplanten Besuch bestätigt."
      },
      "visitNoInspection": {
        "title": "Besuch bestätigt",
        "body": "Der Besuch für die Inspektion am {{when}} wurde bestätigt."
      },
      "request": {
        "title": "Termin bestätigt",
        "body": "{{request}} – die anfragende Person hat den geplanten Besuch bestätigt."
      },
      "visitNoJob": {
        "title": "Besuch bestätigt",
        "body": "Der Besuch für den Auftrag am {{when}} wurde bestätigt."
      },
      "visit": {
        "title": "Besuch bestätigt",
        "body": "Der Besuch für {{work}} am {{when}} wurde bestätigt."
      }
    },
    "asset_request_converted": {
      "toInspection": {
        "title": "Ihre Anfrage wurde in eine Inspektion umgewandelt",
        "body": "{{request}} ist jetzt für die operative Arbeit eingeplant."
      },
      "toJob": {
        "title": "Ihre Anfrage wurde in einen Auftrag umgewandelt",
        "body": "{{request}} steht jetzt in der Arbeitswarteschlange."
      },
      "inspectionUndated": {
        "title": "Inspektion geplant",
        "body": "Für {{request}} ist jetzt eine Inspektion geplant."
      },
      "jobDue": {
        "title": "Ihre Anfrage ist jetzt ein Auftrag",
        "body": "{{request}} ist jetzt ein Auftrag für {{assignee}}, fällig bis {{dueDate}}."
      },
      "inspectionScheduled": {
        "title": "Inspektion geplant",
        "body": "{{request}} – Inspektion geplant für {{scheduledWhen}}."
      },
      "jobDueNoAssignee": {
        "title": "Ihre Anfrage ist jetzt ein Auftrag",
        "body": "{{request}} ist jetzt ein Auftrag, fällig bis {{dueDate}}."
      },
      "job": {
        "title": "Ihre Anfrage ist jetzt ein Auftrag",
        "body": "{{request}} ist jetzt ein Auftrag für {{assignee}}."
      },
      "jobScheduled": {
        "title": "Auftrag geplant",
        "body": "{{request}} – Auftrag für {{assignee}} geplant für {{scheduledDate}}."
      },
      "jobNoAssignee": {
        "title": "Ihre Anfrage ist jetzt ein Auftrag",
        "body": "{{request}} ist jetzt ein Auftrag."
      },
      "jobScheduledNoAssignee": {
        "title": "Auftrag geplant",
        "body": "{{request}} – Auftrag geplant für {{scheduledDate}}."
      }
    },
    "asset_request_created": {
      "noAssetOperatorNoRequestPublicLinkLegacy": {
        "title": "Neue Anfrage für eine Anlage",
        "body": "Ein Betreiber hat eine Anfrage über den öffentlichen Link eingereicht."
      },
      "noAssetOperatorNoRequestPublicLink": {
        "title": "Neue Anfrage für eine Anlage",
        "body": "Ein Betreiber hat eine Anfrage über den öffentlichen Link eingereicht."
      },
      "noAssetContactNoRequestPublicLinkLegacy": {
        "title": "Neue Anfrage für eine Anlage",
        "body": "Ein Kontakt hat eine Anfrage über den öffentlichen Link eingereicht."
      },
      "noAssetContactNoRequestPublicLink": {
        "title": "Neue Anfrage für eine Anlage",
        "body": "Ein Kontakt hat eine Anfrage über den öffentlichen Link eingereicht."
      },
      "operatorNoRequestPublicLinkLegacy": {
        "title": "Neue Anfrage für {{asset}}",
        "body": "Ein Betreiber hat eine Anfrage über den öffentlichen Link eingereicht."
      },
      "operatorNoRequestPublicLink": {
        "title": "Neue Anfrage für {{asset}}",
        "body": "Ein Betreiber hat eine Anfrage über den öffentlichen Link eingereicht."
      },
      "contactNoRequestPublicLinkLegacy": {
        "title": "Neue Anfrage für {{asset}}",
        "body": "Ein Kontakt hat eine Anfrage über den öffentlichen Link eingereicht."
      },
      "contactNoRequestPublicLink": {
        "title": "Neue Anfrage für {{asset}}",
        "body": "Ein Kontakt hat eine Anfrage über den öffentlichen Link eingereicht."
      },
      "noAssetOperatorPublicLink": {
        "title": "Neue Anfrage für eine Anlage",
        "body": "Ein Betreiber hat „{{request}}“ über den öffentlichen Link eingereicht."
      },
      "noAssetNoRequestPublicLinkLegacy": {
        "title": "Neue Anfrage für eine Anlage",
        "body": "{{submitter}} hat eine Anfrage über den öffentlichen Link eingereicht."
      },
      "noAssetNoRequestPublicLink": {
        "title": "Neue Anfrage für eine Anlage",
        "body": "{{submitter}} hat eine Anfrage über den öffentlichen Link eingereicht."
      },
      "noAssetContactPublicLink": {
        "title": "Neue Anfrage für eine Anlage",
        "body": "Ein Kontakt hat „{{request}}“ über den öffentlichen Link eingereicht."
      },
      "operatorPublicLink": {
        "title": "Neue Anfrage für {{asset}}",
        "body": "Ein Betreiber hat „{{request}}“ über den öffentlichen Link eingereicht."
      },
      "noRequestPublicLinkLegacy": {
        "title": "Neue Anfrage für {{asset}}",
        "body": "{{submitter}} hat eine Anfrage über den öffentlichen Link eingereicht."
      },
      "noRequestPublicLink": {
        "title": "Neue Anfrage für {{asset}}",
        "body": "{{submitter}} hat eine Anfrage über den öffentlichen Link eingereicht."
      },
      "contactPublicLink": {
        "title": "Neue Anfrage für {{asset}}",
        "body": "Ein Kontakt hat „{{request}}“ über den öffentlichen Link eingereicht."
      },
      "noAssetPublicLink": {
        "title": "Neue Anfrage für eine Anlage",
        "body": "{{submitter}} hat „{{request}}“ über den öffentlichen Link eingereicht."
      },
      "noAssetOperatorNoRequestLegacy": {
        "title": "Neue Anfrage für eine Anlage",
        "body": "Ein Betreiber hat eine Anfrage eingereicht."
      },
      "noAssetOperatorNoRequest": {
        "title": "Neue Anfrage für eine Anlage",
        "body": "Ein Betreiber hat eine Anfrage eingereicht."
      },
      "noAssetContactNoRequestLegacy": {
        "title": "Neue Anfrage für eine Anlage",
        "body": "Ein Kontakt hat eine Anfrage eingereicht."
      },
      "noAssetContactNoRequest": {
        "title": "Neue Anfrage für eine Anlage",
        "body": "Ein Kontakt hat eine Anfrage eingereicht."
      },
      "publicLink": {
        "title": "Neue Anfrage für {{asset}}",
        "body": "{{submitter}} hat „{{request}}“ über den öffentlichen Link eingereicht."
      },
      "operatorNoRequestLegacy": {
        "title": "Neue Anfrage für {{asset}}",
        "body": "Ein Betreiber hat eine Anfrage eingereicht."
      },
      "operatorNoRequest": {
        "title": "Neue Anfrage für {{asset}}",
        "body": "Ein Betreiber hat eine Anfrage eingereicht."
      },
      "contactNoRequestLegacy": {
        "title": "Neue Anfrage für {{asset}}",
        "body": "Ein Kontakt hat eine Anfrage eingereicht."
      },
      "contactNoRequest": {
        "title": "Neue Anfrage für {{asset}}",
        "body": "Ein Kontakt hat eine Anfrage eingereicht."
      },
      "noAssetOperator": {
        "title": "Neue Anfrage für eine Anlage",
        "body": "Ein Betreiber hat „{{request}}“ eingereicht."
      },
      "noAssetNoRequestLegacy": {
        "title": "Neue Anfrage für eine Anlage",
        "body": "{{submitter}} hat eine Anfrage eingereicht."
      },
      "noAssetNoRequest": {
        "title": "Neue Anfrage für eine Anlage",
        "body": "{{submitter}} hat eine Anfrage eingereicht."
      },
      "noAssetContact": {
        "title": "Neue Anfrage für eine Anlage",
        "body": "Ein Kontakt hat „{{request}}“ eingereicht."
      },
      "operator": {
        "title": "Neue Anfrage für {{asset}}",
        "body": "Ein Betreiber hat „{{request}}“ eingereicht."
      },
      "noRequestLegacy": {
        "title": "Neue Anfrage für {{asset}}",
        "body": "{{submitter}} hat eine Anfrage eingereicht."
      },
      "noRequest": {
        "title": "Neue Anfrage für {{asset}}",
        "body": "{{submitter}} hat eine Anfrage eingereicht."
      },
      "contact": {
        "title": "Neue Anfrage für {{asset}}",
        "body": "Ein Kontakt hat „{{request}}“ eingereicht."
      },
      "noAsset": {
        "title": "Neue Anfrage für eine Anlage",
        "body": "{{submitter}} hat „{{request}}“ eingereicht."
      },
      "default": {
        "title": "Neue Anfrage für {{asset}}",
        "body": "{{submitter}} hat „{{request}}“ eingereicht."
      }
    },
    "asset_request_evidence_requested": {
      "noAsset": {
        "title": "Anfrage aktualisiert",
        "body": "{{request}} wurde für die Anlage aktualisiert. {{note}}"
      },
      "noAssetNoNote": {
        "title": "Anfrage aktualisiert",
        "body": "{{request}} wurde für die Anlage aktualisiert."
      },
      "default": {
        "title": "Anfrage aktualisiert",
        "body": "{{request}} wurde für {{asset}} aktualisiert. {{note}}"
      },
      "noNote": {
        "title": "Anfrage aktualisiert",
        "body": "{{request}} wurde für {{asset}} aktualisiert."
      }
    },
    "asset_request_inspection_cancelled": {
      "noActor": {
        "title": "Inspektion abgebrochen",
        "body": "Das Team hat die Inspektion zu {{request}} abgebrochen. {{note}}"
      },
      "noActorNoNote": {
        "title": "Inspektion abgebrochen",
        "body": "Das Team hat die Inspektion zu {{request}} abgebrochen."
      },
      "default": {
        "title": "Inspektion abgebrochen",
        "body": "{{actor}} hat die Inspektion zu {{request}} abgebrochen. {{note}}"
      },
      "noNote": {
        "title": "Inspektion abgebrochen",
        "body": "{{actor}} hat die Inspektion zu {{request}} abgebrochen."
      }
    },
    "asset_request_inspection_completed": {
      "noActor": {
        "title": "Inspektion abgeschlossen",
        "body": "Das Team hat die Inspektion zu {{request}} abgeschlossen. {{note}}"
      },
      "noActorNoNote": {
        "title": "Inspektion abgeschlossen",
        "body": "Das Team hat die Inspektion zu {{request}} abgeschlossen."
      },
      "default": {
        "title": "Inspektion abgeschlossen",
        "body": "{{actor}} hat die Inspektion zu {{request}} abgeschlossen. {{note}}"
      },
      "noNote": {
        "title": "Inspektion abgeschlossen",
        "body": "{{actor}} hat die Inspektion zu {{request}} abgeschlossen."
      }
    },
    "asset_request_inspection_paused": {
      "noActor": {
        "title": "Inspektion pausiert",
        "body": "Das Team hat die Inspektion zu {{request}} pausiert. {{note}}"
      },
      "noActorNoNote": {
        "title": "Inspektion pausiert",
        "body": "Das Team hat die Inspektion zu {{request}} pausiert."
      },
      "default": {
        "title": "Inspektion pausiert",
        "body": "{{actor}} hat die Inspektion zu {{request}} pausiert. {{note}}"
      },
      "noNote": {
        "title": "Inspektion pausiert",
        "body": "{{actor}} hat die Inspektion zu {{request}} pausiert."
      }
    },
    "asset_request_inspection_reassigned": {
      "toAssigneeNoActor": {
        "title": "Inspektion neu zugewiesen",
        "body": "Das Team hat die Inspektion zu {{request}} an {{assignee}} neu zugewiesen."
      },
      "noActor": {
        "title": "Inspektion neu zugewiesen",
        "body": "Das Team hat die Inspektion zu {{request}} neu zugewiesen. {{note}}"
      },
      "noActorNoNote": {
        "title": "Inspektion neu zugewiesen",
        "body": "Das Team hat die Inspektion zu {{request}} neu zugewiesen."
      },
      "toAssignee": {
        "title": "Inspektion neu zugewiesen",
        "body": "{{actor}} hat die Inspektion zu {{request}} an {{assignee}} neu zugewiesen."
      },
      "default": {
        "title": "Inspektion neu zugewiesen",
        "body": "{{actor}} hat die Inspektion zu {{request}} neu zugewiesen. {{note}}"
      },
      "noNote": {
        "title": "Inspektion neu zugewiesen",
        "body": "{{actor}} hat die Inspektion zu {{request}} neu zugewiesen."
      }
    },
    "asset_request_inspection_resumed": {
      "noActorReopened": {
        "title": "Inspektion fortgesetzt",
        "body": "Das Team hat die Inspektion zu {{request}} fortgesetzt. Die Inspektion wurde wieder geöffnet."
      },
      "reopened": {
        "title": "Inspektion fortgesetzt",
        "body": "{{actor}} hat die Inspektion zu {{request}} fortgesetzt. Die Inspektion wurde wieder geöffnet."
      },
      "noActor": {
        "title": "Inspektion fortgesetzt",
        "body": "Das Team hat die Inspektion zu {{request}} fortgesetzt."
      },
      "default": {
        "title": "Inspektion fortgesetzt",
        "body": "{{actor}} hat die Inspektion zu {{request}} fortgesetzt."
      }
    },
    "asset_request_inspection_started": {
      "noActor": {
        "title": "Inspektion begonnen",
        "body": "Das Team hat mit der Inspektion zu {{request}} begonnen. {{note}}"
      },
      "noActorNoNote": {
        "title": "Inspektion begonnen",
        "body": "Das Team hat mit der Inspektion zu {{request}} begonnen."
      },
      "default": {
        "title": "Inspektion begonnen",
        "body": "{{actor}} hat mit der Inspektion zu {{request}} begonnen. {{note}}"
      },
      "noNote": {
        "title": "Inspektion begonnen",
        "body": "{{actor}} hat mit der Inspektion zu {{request}} begonnen."
      }
    },
    "asset_request_job_cancelled": {
      "noActor": {
        "title": "Auftrag abgebrochen",
        "body": "Das Team hat den Auftrag zu {{request}} abgebrochen. {{note}}"
      },
      "noActorNoNote": {
        "title": "Auftrag abgebrochen",
        "body": "Das Team hat den Auftrag zu {{request}} abgebrochen."
      },
      "default": {
        "title": "Auftrag abgebrochen",
        "body": "{{actor}} hat den Auftrag zu {{request}} abgebrochen. {{note}}"
      },
      "noNote": {
        "title": "Auftrag abgebrochen",
        "body": "{{actor}} hat den Auftrag zu {{request}} abgebrochen."
      }
    },
    "asset_request_job_completed": {
      "noActorNoJobLegacy": {
        "title": "Auftrag abgeschlossen",
        "body": "Das Team hat den Auftrag zu Ihrer Anfrage abgeschlossen. Prüfen Sie die Arbeit und bestätigen Sie die Behebung."
      },
      "noActorNoJob": {
        "title": "Auftrag abgeschlossen",
        "body": "Das Team hat den Auftrag zu Ihrer Anfrage abgeschlossen. Prüfen Sie die Arbeit und bestätigen Sie die Behebung."
      },
      "noJobLegacy": {
        "title": "Auftrag abgeschlossen",
        "body": "{{actor}} hat den Auftrag zu Ihrer Anfrage abgeschlossen. Prüfen Sie die Arbeit und bestätigen Sie die Behebung."
      },
      "noJob": {
        "title": "Auftrag abgeschlossen",
        "body": "{{actor}} hat den Auftrag zu Ihrer Anfrage abgeschlossen. Prüfen Sie die Arbeit und bestätigen Sie die Behebung."
      },
      "noActor": {
        "title": "Auftrag abgeschlossen",
        "body": "Das Team hat den Auftrag „{{job}}“ abgeschlossen. Prüfen Sie die Arbeit und bestätigen Sie die Behebung."
      },
      "default": {
        "title": "Auftrag abgeschlossen",
        "body": "{{actor}} hat den Auftrag „{{job}}“ abgeschlossen. Prüfen Sie die Arbeit und bestätigen Sie die Behebung."
      }
    },
    "asset_request_job_created": {
      "noActorOutsideRepairsLegacy": {
        "title": "Auftrag aus Anfrage erstellt",
        "body": "Das Team hat zu {{request}} einen Auftrag außerhalb der genehmigten Reparaturen erstellt: „{{job}}“."
      },
      "outsideRepairsLegacy": {
        "title": "Auftrag aus Anfrage erstellt",
        "body": "{{actor}} hat zu {{request}} einen Auftrag außerhalb der genehmigten Reparaturen erstellt: „{{job}}“."
      },
      "noActorLegacy": {
        "title": "Auftrag aus Anfrage erstellt",
        "body": "Das Team hat zu {{request}} einen Auftrag erstellt: „{{job}}“."
      },
      "noActorFromRepairLegacy": {
        "title": "Auftrag aus Anfrage erstellt",
        "body": "Das Team hat zu {{request}} einen Auftrag aus einer genehmigten Reparatur erstellt: „{{job}}“."
      },
      "noActorFollowUpLegacy": {
        "title": "Auftrag aus Anfrage erstellt",
        "body": "Das Team hat zu {{request}} einen Folgeauftrag vorgeschlagen: „{{job}}“."
      },
      "defaultLegacy": {
        "title": "Auftrag aus Anfrage erstellt",
        "body": "{{actor}} hat zu {{request}} einen Auftrag erstellt: „{{job}}“."
      },
      "fromRepairLegacy": {
        "title": "Auftrag aus Anfrage erstellt",
        "body": "{{actor}} hat zu {{request}} einen Auftrag aus einer genehmigten Reparatur erstellt: „{{job}}“."
      },
      "followUpLegacy": {
        "title": "Auftrag aus Anfrage erstellt",
        "body": "{{actor}} hat zu {{request}} einen Folgeauftrag vorgeschlagen: „{{job}}“."
      },
      "noActorOutsideRepairs": {
        "title": "Auftrag aus Anfrage erstellt",
        "body": "Das Team hat zu {{request}} einen Auftrag außerhalb der genehmigten Reparaturen erstellt: „{{job}}“."
      },
      "noActorFromRepair": {
        "title": "Auftrag aus Anfrage erstellt",
        "body": "Das Team hat zu {{request}} einen Auftrag aus einer genehmigten Reparatur erstellt: „{{job}}“."
      },
      "noActorFollowUp": {
        "title": "Auftrag aus Anfrage erstellt",
        "body": "Das Team hat zu {{request}} einen Folgeauftrag vorgeschlagen: „{{job}}“."
      },
      "noActor": {
        "title": "Auftrag aus Anfrage erstellt",
        "body": "Das Team hat zu {{request}} einen Auftrag erstellt: „{{job}}“."
      },
      "outsideRepairs": {
        "title": "Auftrag aus Anfrage erstellt",
        "body": "{{actor}} hat zu {{request}} einen Auftrag außerhalb der genehmigten Reparaturen erstellt: „{{job}}“."
      },
      "fromRepair": {
        "title": "Auftrag aus Anfrage erstellt",
        "body": "{{actor}} hat zu {{request}} einen Auftrag aus einer genehmigten Reparatur erstellt: „{{job}}“."
      },
      "followUp": {
        "title": "Auftrag aus Anfrage erstellt",
        "body": "{{actor}} hat zu {{request}} einen Folgeauftrag vorgeschlagen: „{{job}}“."
      },
      "default": {
        "title": "Auftrag aus Anfrage erstellt",
        "body": "{{actor}} hat zu {{request}} einen Auftrag erstellt: „{{job}}“."
      }
    },
    "asset_request_job_paused": {
      "noActor": {
        "title": "Auftrag pausiert",
        "body": "Das Team hat den Auftrag zu {{request}} pausiert. {{note}}"
      },
      "noActorNoNote": {
        "title": "Auftrag pausiert",
        "body": "Das Team hat den Auftrag zu {{request}} pausiert."
      },
      "default": {
        "title": "Auftrag pausiert",
        "body": "{{actor}} hat den Auftrag zu {{request}} pausiert. {{note}}"
      },
      "noNote": {
        "title": "Auftrag pausiert",
        "body": "{{actor}} hat den Auftrag zu {{request}} pausiert."
      }
    },
    "asset_request_job_resumed": {
      "noActor": {
        "title": "Auftrag fortgesetzt",
        "body": "Das Team hat den Auftrag zu {{request}} fortgesetzt. {{note}}"
      },
      "noActorNoNote": {
        "title": "Auftrag fortgesetzt",
        "body": "Das Team hat den Auftrag zu {{request}} fortgesetzt."
      },
      "default": {
        "title": "Auftrag fortgesetzt",
        "body": "{{actor}} hat den Auftrag zu {{request}} fortgesetzt. {{note}}"
      },
      "noNote": {
        "title": "Auftrag fortgesetzt",
        "body": "{{actor}} hat den Auftrag zu {{request}} fortgesetzt."
      }
    },
    "asset_request_job_started": {
      "noActor": {
        "title": "Auftrag begonnen",
        "body": "Das Team hat mit dem Auftrag zu {{request}} begonnen. {{note}}"
      },
      "noActorNoNote": {
        "title": "Auftrag begonnen",
        "body": "Das Team hat mit dem Auftrag zu {{request}} begonnen."
      },
      "default": {
        "title": "Auftrag begonnen",
        "body": "{{actor}} hat mit dem Auftrag zu {{request}} begonnen. {{note}}"
      },
      "noNote": {
        "title": "Auftrag begonnen",
        "body": "{{actor}} hat mit dem Auftrag zu {{request}} begonnen."
      }
    },
    "asset_request_rejected": {
      "withNote": {
        "title": "Ihre Anfrage wurde abgelehnt",
        "body": "„{{request}}“ wurde abgelehnt: {{note}}"
      },
      "default": {
        "title": "Ihre Anfrage wurde abgelehnt",
        "body": "„{{request}}“ wurde abgelehnt."
      }
    },
    "asset_request_report_shared": {
      "forYouLegacy": {
        "title": "Inspektionsbericht geteilt",
        "body": "Der Bericht zu {{request}} ist bereit zu Ihrer Prüfung: {{findingCount}} Befund(e) zu bearbeiten."
      },
      "defaultLegacy": {
        "title": "Inspektionsbericht geteilt",
        "body": "Der Bericht zu {{request}} ist bereit zur Prüfung: {{findingCount}} Befund(e) mit vorgeschlagener Reparatur."
      },
      "forYouPlainLegacy": {
        "title": "Inspektionsbericht geteilt",
        "body": "Der Bericht zu {{request}} ist bereit zu Ihrer Prüfung."
      },
      "plainLegacy": {
        "title": "Inspektionsbericht geteilt",
        "body": "Der Bericht zu {{request}} ist bereit zur Prüfung."
      },
      "forYou": {
        "title": "Inspektionsbericht geteilt",
        "body": "Der Bericht zu {{request}} ist bereit zu Ihrer Prüfung: {{findingCount}} Befund(e) zu bearbeiten."
      },
      "default": {
        "title": "Inspektionsbericht geteilt",
        "body": "Der Bericht zu {{request}} ist bereit zur Prüfung: {{findingCount}} Befund(e) mit vorgeschlagener Reparatur."
      },
      "forYouPlain": {
        "title": "Inspektionsbericht geteilt",
        "body": "Der Bericht zu {{request}} ist bereit zu Ihrer Prüfung."
      },
      "plain": {
        "title": "Inspektionsbericht geteilt",
        "body": "Der Bericht zu {{request}} ist bereit zur Prüfung."
      }
    },
    "asset_request_requested_reschedule": {
      "visitNoInspectionNoPreference": {
        "title": "Andere Besuchszeit gewünscht",
        "body": "Für die Inspektion wurde eine andere Zeit gewünscht. Keine Wunschzeit angegeben."
      },
      "visitNoJobNoPreference": {
        "title": "Andere Besuchszeit gewünscht",
        "body": "Für den Auftrag wurde eine andere Zeit gewünscht. Keine Wunschzeit angegeben."
      },
      "visitNoInspection": {
        "title": "Andere Besuchszeit gewünscht",
        "body": "Für die Inspektion wurde eine andere Zeit gewünscht. Wunschtermin: {{preferredDate}} · {{period}} · {{note}}"
      },
      "visitNoInspectionNoNote": {
        "title": "Andere Besuchszeit gewünscht",
        "body": "Für die Inspektion wurde eine andere Zeit gewünscht. Wunschtermin: {{preferredDate}} · {{period}}"
      },
      "visitNoInspectionNoPeriod": {
        "title": "Andere Besuchszeit gewünscht",
        "body": "Für die Inspektion wurde eine andere Zeit gewünscht. Wunschtermin: {{preferredDate}} · {{note}}"
      },
      "visitNoPreference": {
        "title": "Andere Besuchszeit gewünscht",
        "body": "Für {{work}} wurde eine andere Zeit gewünscht. Keine Wunschzeit angegeben."
      },
      "visitNoInspectionDateOnly": {
        "title": "Andere Besuchszeit gewünscht",
        "body": "Für die Inspektion wurde eine andere Zeit gewünscht. Wunschtermin: {{preferredDate}}"
      },
      "visitNoJob": {
        "title": "Andere Besuchszeit gewünscht",
        "body": "Für den Auftrag wurde eine andere Zeit gewünscht. Wunschtermin: {{preferredDate}} · {{period}} · {{note}}"
      },
      "visitNoJobNoNote": {
        "title": "Andere Besuchszeit gewünscht",
        "body": "Für den Auftrag wurde eine andere Zeit gewünscht. Wunschtermin: {{preferredDate}} · {{period}}"
      },
      "visitNoJobNoPeriod": {
        "title": "Andere Besuchszeit gewünscht",
        "body": "Für den Auftrag wurde eine andere Zeit gewünscht. Wunschtermin: {{preferredDate}} · {{note}}"
      },
      "visitNoInspectionNoDate": {
        "title": "Andere Besuchszeit gewünscht",
        "body": "Für die Inspektion wurde eine andere Zeit gewünscht. Wunschzeit: {{period}} · {{note}}"
      },
      "visitNoJobDateOnly": {
        "title": "Andere Besuchszeit gewünscht",
        "body": "Für den Auftrag wurde eine andere Zeit gewünscht. Wunschtermin: {{preferredDate}}"
      },
      "visit": {
        "title": "Andere Besuchszeit gewünscht",
        "body": "Für {{work}} wurde eine andere Zeit gewünscht. Wunschtermin: {{preferredDate}} · {{period}} · {{note}}"
      },
      "visitNoInspectionPeriodOnly": {
        "title": "Andere Besuchszeit gewünscht",
        "body": "Für die Inspektion wurde eine andere Zeit gewünscht. Wunschzeit: {{period}}"
      },
      "visitNoInspectionNoteOnly": {
        "title": "Andere Besuchszeit gewünscht",
        "body": "Für die Inspektion wurde eine andere Zeit gewünscht. {{note}}"
      },
      "visitNoNote": {
        "title": "Andere Besuchszeit gewünscht",
        "body": "Für {{work}} wurde eine andere Zeit gewünscht. Wunschtermin: {{preferredDate}} · {{period}}"
      },
      "visitNoPeriod": {
        "title": "Andere Besuchszeit gewünscht",
        "body": "Für {{work}} wurde eine andere Zeit gewünscht. Wunschtermin: {{preferredDate}} · {{note}}"
      },
      "visitNoJobNoDate": {
        "title": "Andere Besuchszeit gewünscht",
        "body": "Für den Auftrag wurde eine andere Zeit gewünscht. Wunschzeit: {{period}} · {{note}}"
      },
      "requestNoRequest": {
        "title": "Neue Zeit gewünscht",
        "body": "Anfrage – die anfragende Person hat um eine andere Zeit gebeten. ({{preferredDate}} {{periodLabel}})"
      },
      "requestNoRequestNoPeriod": {
        "title": "Neue Zeit gewünscht",
        "body": "Anfrage – die anfragende Person hat um eine andere Zeit gebeten. ({{preferredDate}})"
      },
      "visitDateOnly": {
        "title": "Andere Besuchszeit gewünscht",
        "body": "Für {{work}} wurde eine andere Zeit gewünscht. Wunschtermin: {{preferredDate}}"
      },
      "visitNoJobPeriodOnly": {
        "title": "Andere Besuchszeit gewünscht",
        "body": "Für den Auftrag wurde eine andere Zeit gewünscht. Wunschzeit: {{period}}"
      },
      "visitNoJobNoteOnly": {
        "title": "Andere Besuchszeit gewünscht",
        "body": "Für den Auftrag wurde eine andere Zeit gewünscht. {{note}}"
      },
      "requestNoRequestNoPreference": {
        "title": "Neue Zeit gewünscht",
        "body": "Anfrage – die anfragende Person hat um eine andere Zeit gebeten."
      },
      "visitNoDate": {
        "title": "Andere Besuchszeit gewünscht",
        "body": "Für {{work}} wurde eine andere Zeit gewünscht. Wunschzeit: {{period}} · {{note}}"
      },
      "request": {
        "title": "Neue Zeit gewünscht",
        "body": "{{request}} – die anfragende Person hat um eine andere Zeit gebeten. ({{preferredDate}} {{periodLabel}})"
      },
      "requestNoPeriod": {
        "title": "Neue Zeit gewünscht",
        "body": "{{request}} – die anfragende Person hat um eine andere Zeit gebeten. ({{preferredDate}})"
      },
      "visitPeriodOnly": {
        "title": "Andere Besuchszeit gewünscht",
        "body": "Für {{work}} wurde eine andere Zeit gewünscht. Wunschzeit: {{period}}"
      },
      "visitNoteOnly": {
        "title": "Andere Besuchszeit gewünscht",
        "body": "Für {{work}} wurde eine andere Zeit gewünscht. {{note}}"
      },
      "requestNoPreference": {
        "title": "Neue Zeit gewünscht",
        "body": "{{request}} – die anfragende Person hat um eine andere Zeit gebeten."
      }
    },
    "asset_request_requester_cancelled": {
      "noRequest": {
        "title": "Anfrage zurückgezogen",
        "body": "Die Anfrage wurde von der anfragenden Person zurückgezogen. {{reason}}"
      },
      "noRequestNoReason": {
        "title": "Anfrage zurückgezogen",
        "body": "Die Anfrage wurde von der anfragenden Person zurückgezogen."
      },
      "default": {
        "title": "Anfrage zurückgezogen",
        "body": "{{request}} wurde von der anfragenden Person zurückgezogen. {{reason}}"
      },
      "noReason": {
        "title": "Anfrage zurückgezogen",
        "body": "{{request}} wurde von der anfragenden Person zurückgezogen."
      }
    },
    "asset_request_response_received": {
      "approvedLegacy": {
        "title": "Antwort zum Bericht erhalten",
        "body": "Der Bericht zu {{request}} wurde genehmigt."
      },
      "rejectedLegacy": {
        "title": "Antwort zum Bericht erhalten",
        "body": "Der Bericht zu {{request}} wurde abgelehnt."
      },
      "defaultLegacy": {
        "title": "Antwort zum Bericht erhalten",
        "body": "Der Bericht zu {{request}} wurde abgelehnt. {{reason}}"
      },
      "approved": {
        "title": "Antwort zum Bericht erhalten",
        "body": "Der Bericht zu {{request}} wurde genehmigt."
      },
      "rejected": {
        "title": "Antwort zum Bericht erhalten",
        "body": "Der Bericht zu {{request}} wurde abgelehnt."
      },
      "default": {
        "title": "Antwort zum Bericht erhalten",
        "body": "Der Bericht zu {{request}} wurde abgelehnt. {{reason}}"
      }
    },
    "asset_request_rework_requested": {
      "requesterNoRequesterNoRequestNoReasonLegacy": {
        "title": "Nachbesserung angefordert",
        "body": "Die anfragende Person hat zur Anfrage eine Nachbesserung angefordert."
      },
      "requesterNoRequesterNoReasonLegacy": {
        "title": "Nachbesserung angefordert",
        "body": "Die anfragende Person hat zu „{{request}}“ eine Nachbesserung angefordert."
      },
      "requesterNoRequestNoReasonLegacy": {
        "title": "Nachbesserung angefordert",
        "body": "{{requester}} hat zur Anfrage eine Nachbesserung angefordert."
      },
      "requesterNoReasonLegacy": {
        "title": "Nachbesserung angefordert",
        "body": "{{requester}} hat zu „{{request}}“ eine Nachbesserung angefordert."
      },
      "requesterNoRequesterNoRequestLegacy": {
        "title": "Nachbesserung angefordert",
        "body": "Die anfragende Person hat zur Anfrage eine Nachbesserung angefordert: {{reason}}"
      },
      "requesterNoRequestLegacy": {
        "title": "Nachbesserung angefordert",
        "body": "{{requester}} hat zur Anfrage eine Nachbesserung angefordert: {{reason}}"
      },
      "requesterNoRequesterNoRequestNoReason": {
        "title": "Nachbesserung angefordert",
        "body": "Die anfragende Person hat zur Anfrage eine Nachbesserung angefordert."
      },
      "requesterNoRequesterNoReason": {
        "title": "Nachbesserung angefordert",
        "body": "Die anfragende Person hat zu „{{request}}“ eine Nachbesserung angefordert."
      },
      "requesterNoRequestNoReason": {
        "title": "Nachbesserung angefordert",
        "body": "{{requester}} hat zur Anfrage eine Nachbesserung angefordert."
      },
      "requesterNoReason": {
        "title": "Nachbesserung angefordert",
        "body": "{{requester}} hat zu „{{request}}“ eine Nachbesserung angefordert."
      },
      "requesterNoRequesterNoRequest": {
        "title": "Nachbesserung angefordert",
        "body": "Die anfragende Person hat zur Anfrage eine Nachbesserung angefordert: {{reason}}"
      },
      "requesterNoRequester": {
        "title": "Nachbesserung angefordert",
        "body": "Die anfragende Person hat zu „{{request}}“ eine Nachbesserung angefordert: {{reason}}"
      },
      "requesterNoRequest": {
        "title": "Nachbesserung angefordert",
        "body": "{{requester}} hat zur Anfrage eine Nachbesserung angefordert: {{reason}}"
      },
      "teamNoActor": {
        "title": "Nachbesserung angefordert",
        "body": "Das Team hat zu {{request}} eine Nachbesserung angefordert. {{note}}"
      },
      "teamNoActorNoNote": {
        "title": "Nachbesserung angefordert",
        "body": "Das Team hat zu {{request}} eine Nachbesserung angefordert."
      },
      "requester": {
        "title": "Nachbesserung angefordert",
        "body": "{{requester}} hat zu „{{request}}“ eine Nachbesserung angefordert: {{reason}}"
      },
      "team": {
        "title": "Nachbesserung angefordert",
        "body": "{{actor}} hat zu {{request}} eine Nachbesserung angefordert. {{note}}"
      },
      "teamNoNote": {
        "title": "Nachbesserung angefordert",
        "body": "{{actor}} hat zu {{request}} eine Nachbesserung angefordert."
      }
    },
    "asset_request_scheduled": {
      "scheduled": {
        "title": "Ihre Anfrage wurde eingeplant",
        "body": "{{request}} ist für {{scheduledDate}} geplant."
      },
      "rescheduled": {
        "title": "Ihr Besuch wurde verschoben",
        "body": "{{request}} – neuer Termin: {{newWhen}}."
      }
    },
    "asset_retired": {
      "noAsset": {
        "title": "Anlage ausgemustert",
        "body": "Eine Anlage wurde ausgemustert ({{reason}}). Neue Inspektionen oder Aufträge sind dafür nicht mehr möglich. {{note}}"
      },
      "noAssetNoNote": {
        "title": "Anlage ausgemustert",
        "body": "Eine Anlage wurde ausgemustert ({{reason}}). Neue Inspektionen oder Aufträge sind dafür nicht mehr möglich."
      },
      "noAssetNoReason": {
        "title": "Anlage ausgemustert",
        "body": "Eine Anlage wurde ausgemustert. Neue Inspektionen oder Aufträge sind dafür nicht mehr möglich. {{note}}"
      },
      "noAssetNoReasonNoNote": {
        "title": "Anlage ausgemustert",
        "body": "Eine Anlage wurde ausgemustert. Neue Inspektionen oder Aufträge sind dafür nicht mehr möglich."
      },
      "default": {
        "title": "Anlage ausgemustert",
        "body": "{{asset}} wurde ausgemustert ({{reason}}). Neue Inspektionen oder Aufträge sind dafür nicht mehr möglich. {{note}}"
      },
      "noNote": {
        "title": "Anlage ausgemustert",
        "body": "{{asset}} wurde ausgemustert ({{reason}}). Neue Inspektionen oder Aufträge sind dafür nicht mehr möglich."
      },
      "noReason": {
        "title": "Anlage ausgemustert",
        "body": "{{asset}} wurde ausgemustert. Neue Inspektionen oder Aufträge sind dafür nicht mehr möglich. {{note}}"
      },
      "noReasonNoNote": {
        "title": "Anlage ausgemustert",
        "body": "{{asset}} wurde ausgemustert. Neue Inspektionen oder Aufträge sind dafür nicht mehr möglich."
      }
    },
    "asset_share_accepted": {
      "noContactNoAsset": {
        "title": "Anlagenfreigabe angenommen",
        "body": "Ein Kontakt hat den Zugriff auf die Anlage angenommen."
      },
      "noAsset": {
        "title": "Anlagenfreigabe angenommen",
        "body": "{{contact}} hat den Zugriff auf die Anlage angenommen."
      },
      "noContact": {
        "title": "Anlagenfreigabe angenommen",
        "body": "Ein Kontakt hat den Zugriff auf {{asset}} angenommen."
      },
      "default": {
        "title": "Anlagenfreigabe angenommen",
        "body": "{{contact}} hat den Zugriff auf {{asset}} angenommen."
      }
    },
    "asset_share_declined": {
      "noContactNoAsset": {
        "title": "Anlagenfreigabe abgelehnt",
        "body": "Ein Kontakt hat den Zugriff auf die Anlage abgelehnt."
      },
      "noAsset": {
        "title": "Anlagenfreigabe abgelehnt",
        "body": "{{contact}} hat den Zugriff auf die Anlage abgelehnt."
      },
      "noContact": {
        "title": "Anlagenfreigabe abgelehnt",
        "body": "Ein Kontakt hat den Zugriff auf {{asset}} abgelehnt."
      },
      "default": {
        "title": "Anlagenfreigabe abgelehnt",
        "body": "{{contact}} hat den Zugriff auf {{asset}} abgelehnt."
      }
    },
    "asset_share_ended": {
      "noAsset": {
        "title": "Geteilte Anlage ausgemustert",
        "body": "Eine Anlage wurde von ihrem Eigentümer ausgemustert, daher ist Ihr Zugriff darauf beendet. Alles, was Sie dazu gemeldet haben, bleibt beim Eigentümer gespeichert."
      },
      "default": {
        "title": "Geteilte Anlage ausgemustert",
        "body": "{{asset}} wurde vom Eigentümer ausgemustert, daher ist Ihr Zugriff darauf beendet. Alles, was Sie dazu gemeldet haben, bleibt beim Eigentümer gespeichert."
      }
    },
    "asset_team_assigned": {
      "noTeam": {
        "title": "Neue Anlage in Ihrem Team",
        "body": "{{asset}} wurde Ihrem Team zugewiesen."
      },
      "default": {
        "title": "Neue Anlage in Ihrem Team",
        "body": "{{asset}} wurde dem Team {{team}} zugewiesen."
      }
    },
    "asset_team_removed": {
      "default": {
        "title": "Anlage aus Ihrem Team verschoben",
        "body": "{{asset}} ist Ihrem Team nicht mehr zugewiesen."
      }
    },
    "automation_notice": {
      "default": {
        "title": "{{title}}",
        "body": "{{body}}"
      }
    },
    "completion_submitted": {
      "requesterFirstNoActorNoJobNoRequesterLegacy": {
        "title": "Auftrag abgeschlossen – zuerst bestätigt die anfragende Person",
        "body": "Eine Kollegin oder ein Kollege hat einen Auftrag abgeschlossen. Die anfragende Person bestätigt zuerst die Behebung, danach verifizieren Sie."
      },
      "requesterFirstNoActorNoJobNoRequester": {
        "title": "Auftrag abgeschlossen – zuerst bestätigt die anfragende Person",
        "body": "Eine Kollegin oder ein Kollege hat einen Auftrag abgeschlossen. Die anfragende Person bestätigt zuerst die Behebung, danach verifizieren Sie."
      },
      "requesterFirstNoActorNoRequester": {
        "title": "Auftrag abgeschlossen – zuerst bestätigt die anfragende Person",
        "body": "Eine Kollegin oder ein Kollege hat „{{job}}“ abgeschlossen. Die anfragende Person bestätigt zuerst die Behebung, danach verifizieren Sie."
      },
      "requesterFirstNoJobNoRequesterLegacy": {
        "title": "Auftrag abgeschlossen – zuerst bestätigt die anfragende Person",
        "body": "{{actor}} hat einen Auftrag abgeschlossen. Die anfragende Person bestätigt zuerst die Behebung, danach verifizieren Sie."
      },
      "requesterFirstNoJobNoRequester": {
        "title": "Auftrag abgeschlossen – zuerst bestätigt die anfragende Person",
        "body": "{{actor}} hat einen Auftrag abgeschlossen. Die anfragende Person bestätigt zuerst die Behebung, danach verifizieren Sie."
      },
      "requesterFirstNoActorNoJobLegacy": {
        "title": "Auftrag abgeschlossen – zuerst bestätigt die anfragende Person",
        "body": "Eine Kollegin oder ein Kollege hat einen Auftrag abgeschlossen. {{requester}} bestätigt zuerst die Behebung, danach verifizieren Sie."
      },
      "requesterFirstNoActorNoJob": {
        "title": "Auftrag abgeschlossen – zuerst bestätigt die anfragende Person",
        "body": "Eine Kollegin oder ein Kollege hat einen Auftrag abgeschlossen. {{requester}} bestätigt zuerst die Behebung, danach verifizieren Sie."
      },
      "requesterFirstNoRequester": {
        "title": "Auftrag abgeschlossen – zuerst bestätigt die anfragende Person",
        "body": "{{actor}} hat „{{job}}“ abgeschlossen. Die anfragende Person bestätigt zuerst die Behebung, danach verifizieren Sie."
      },
      "requesterFirstNoActor": {
        "title": "Auftrag abgeschlossen – zuerst bestätigt die anfragende Person",
        "body": "Eine Kollegin oder ein Kollege hat „{{job}}“ abgeschlossen. {{requester}} bestätigt zuerst die Behebung, danach verifizieren Sie."
      },
      "requesterFirstNoJobLegacy": {
        "title": "Auftrag abgeschlossen – zuerst bestätigt die anfragende Person",
        "body": "{{actor}} hat einen Auftrag abgeschlossen. {{requester}} bestätigt zuerst die Behebung, danach verifizieren Sie."
      },
      "requesterFirstNoJob": {
        "title": "Auftrag abgeschlossen – zuerst bestätigt die anfragende Person",
        "body": "{{actor}} hat einen Auftrag abgeschlossen. {{requester}} bestätigt zuerst die Behebung, danach verifizieren Sie."
      },
      "requesterFirst": {
        "title": "Auftrag abgeschlossen – zuerst bestätigt die anfragende Person",
        "body": "{{actor}} hat „{{job}}“ abgeschlossen. {{requester}} bestätigt zuerst die Behebung, danach verifizieren Sie."
      },
      "forApprovalSelf": {
        "title": "Ihr Abschluss wartet auf Ihre Prüfung",
        "body": "Sie haben „{{job}}“ abgeschlossen. Prüfen Sie den Auftrag, um ihn zu schließen."
      },
      "forApprovalSelfNoJob": {
        "title": "Ihr Abschluss wartet auf Ihre Prüfung",
        "body": "Sie haben einen Auftrag abgeschlossen. Prüfen Sie ihn, um ihn zu schließen."
      },
      "forApprovalNoActorNoJobLegacy": {
        "title": "Auftragsabschluss zur Genehmigung eingereicht",
        "body": "Eine Kollegin oder ein Kollege hat einen Auftrag abgeschlossen. Prüfen und genehmigen Sie ihn."
      },
      "forApprovalNoActorNoJob": {
        "title": "Auftragsabschluss zur Genehmigung eingereicht",
        "body": "Eine Kollegin oder ein Kollege hat einen Auftrag abgeschlossen. Prüfen und genehmigen Sie ihn."
      },
      "forApprovalNoActor": {
        "title": "Auftragsabschluss zur Genehmigung eingereicht",
        "body": "Eine Kollegin oder ein Kollege hat „{{job}}“ abgeschlossen. Prüfen und genehmigen Sie ihn."
      },
      "forApprovalNoJobLegacy": {
        "title": "Auftragsabschluss zur Genehmigung eingereicht",
        "body": "{{actor}} hat einen Auftrag abgeschlossen. Prüfen und genehmigen Sie ihn."
      },
      "forApprovalNoJob": {
        "title": "Auftragsabschluss zur Genehmigung eingereicht",
        "body": "{{actor}} hat einen Auftrag abgeschlossen. Prüfen und genehmigen Sie ihn."
      },
      "forApproval": {
        "title": "Auftragsabschluss zur Genehmigung eingereicht",
        "body": "{{actor}} hat „{{job}}“ abgeschlossen. Prüfen und genehmigen Sie ihn."
      }
    },
    "document_expiring": {
      "certificateNoDocument": {
        "title": "Bald ablaufendes Zertifikat",
        "body": "Ein Dokument · {{asset}} läuft am {{expiryDate}} ab."
      },
      "certificateNoDocumentNoAsset": {
        "title": "Bald ablaufendes Zertifikat",
        "body": "Ein Dokument läuft am {{expiryDate}} ab."
      },
      "documentNoDocument": {
        "title": "Bald ablaufendes Dokument",
        "body": "Ein Dokument · {{asset}} läuft am {{expiryDate}} ab."
      },
      "documentNoDocumentNoAsset": {
        "title": "Bald ablaufendes Dokument",
        "body": "Ein Dokument läuft am {{expiryDate}} ab."
      },
      "certificate": {
        "title": "Bald ablaufendes Zertifikat",
        "body": "{{document}} · {{asset}} läuft am {{expiryDate}} ab."
      },
      "certificateNoAsset": {
        "title": "Bald ablaufendes Zertifikat",
        "body": "{{document}} läuft am {{expiryDate}} ab."
      },
      "document": {
        "title": "Bald ablaufendes Dokument",
        "body": "{{document}} · {{asset}} läuft am {{expiryDate}} ab."
      },
      "documentNoAsset": {
        "title": "Bald ablaufendes Dokument",
        "body": "{{document}} läuft am {{expiryDate}} ab."
      }
    },
    "document_rejected": {
      "noValidatorNoAsset": {
        "title": "Dokument abgelehnt",
        "body": "Die validierende Person hat „{{document}}“ für eine Anlage abgelehnt. Grund: {{reason}}"
      },
      "noValidator": {
        "title": "Dokument abgelehnt",
        "body": "Die validierende Person hat „{{document}}“ für {{asset}} abgelehnt. Grund: {{reason}}"
      },
      "noValidatorNoAssetNoReason": {
        "title": "Dokument abgelehnt",
        "body": "Die validierende Person hat „{{document}}“ für eine Anlage abgelehnt."
      },
      "noAsset": {
        "title": "Dokument abgelehnt",
        "body": "{{validator}} hat „{{document}}“ für eine Anlage abgelehnt. Grund: {{reason}}"
      },
      "noValidatorNoReason": {
        "title": "Dokument abgelehnt",
        "body": "Die validierende Person hat „{{document}}“ für {{asset}} abgelehnt."
      },
      "default": {
        "title": "Dokument abgelehnt",
        "body": "{{validator}} hat „{{document}}“ für {{asset}} abgelehnt. Grund: {{reason}}"
      },
      "noAssetNoReason": {
        "title": "Dokument abgelehnt",
        "body": "{{validator}} hat „{{document}}“ für eine Anlage abgelehnt."
      },
      "noReason": {
        "title": "Dokument abgelehnt",
        "body": "{{validator}} hat „{{document}}“ für {{asset}} abgelehnt."
      }
    },
    "document_validated": {
      "noValidatorNoAsset": {
        "title": "Dokument validiert",
        "body": "Die validierende Person hat „{{document}}“ für eine Anlage validiert."
      },
      "noValidator": {
        "title": "Dokument validiert",
        "body": "Die validierende Person hat „{{document}}“ für {{asset}} validiert."
      },
      "noAsset": {
        "title": "Dokument validiert",
        "body": "{{validator}} hat „{{document}}“ für eine Anlage validiert."
      },
      "default": {
        "title": "Dokument validiert",
        "body": "{{validator}} hat „{{document}}“ für {{asset}} validiert."
      }
    },
    "document_validation_requested": {
      "reminderNoRequesterNoAsset": {
        "title": "Erinnerung: „{{document}}“ validieren",
        "body": "Eine Kollegin oder ein Kollege hat Sie daran erinnert, {{documentType}} für eine Anlage zu validieren (läuft am {{expiryDate}} ab)."
      },
      "reminderNoRequester": {
        "title": "Erinnerung: „{{document}}“ validieren",
        "body": "Eine Kollegin oder ein Kollege hat Sie daran erinnert, {{documentType}} für {{asset}} zu validieren (läuft am {{expiryDate}} ab)."
      },
      "reminderNoAsset": {
        "title": "Erinnerung: „{{document}}“ validieren",
        "body": "{{requester}} hat Sie daran erinnert, {{documentType}} für eine Anlage zu validieren (läuft am {{expiryDate}} ab)."
      },
      "reminderNoRequesterNoAssetNoExpiry": {
        "title": "Erinnerung: „{{document}}“ validieren",
        "body": "Eine Kollegin oder ein Kollege hat Sie daran erinnert, {{documentType}} für eine Anlage zu validieren."
      },
      "requestNoRequesterNoAsset": {
        "title": "„{{document}}“ validieren",
        "body": "Eine Kollegin oder ein Kollege hat Sie gebeten, {{documentType}} für eine Anlage zu validieren (läuft am {{expiryDate}} ab)."
      },
      "reminder": {
        "title": "Erinnerung: „{{document}}“ validieren",
        "body": "{{requester}} hat Sie daran erinnert, {{documentType}} für {{asset}} zu validieren (läuft am {{expiryDate}} ab)."
      },
      "reminderNoRequesterNoExpiry": {
        "title": "Erinnerung: „{{document}}“ validieren",
        "body": "Eine Kollegin oder ein Kollege hat Sie daran erinnert, {{documentType}} für {{asset}} zu validieren."
      },
      "requestNoRequester": {
        "title": "„{{document}}“ validieren",
        "body": "Eine Kollegin oder ein Kollege hat Sie gebeten, {{documentType}} für {{asset}} zu validieren (läuft am {{expiryDate}} ab)."
      },
      "reminderNoAssetNoExpiry": {
        "title": "Erinnerung: „{{document}}“ validieren",
        "body": "{{requester}} hat Sie daran erinnert, {{documentType}} für eine Anlage zu validieren."
      },
      "requestNoAsset": {
        "title": "„{{document}}“ validieren",
        "body": "{{requester}} hat Sie gebeten, {{documentType}} für eine Anlage zu validieren (läuft am {{expiryDate}} ab)."
      },
      "requestNoRequesterNoAssetNoExpiry": {
        "title": "„{{document}}“ validieren",
        "body": "Eine Kollegin oder ein Kollege hat Sie gebeten, {{documentType}} für eine Anlage zu validieren."
      },
      "reminderNoExpiry": {
        "title": "Erinnerung: „{{document}}“ validieren",
        "body": "{{requester}} hat Sie daran erinnert, {{documentType}} für {{asset}} zu validieren."
      },
      "request": {
        "title": "„{{document}}“ validieren",
        "body": "{{requester}} hat Sie gebeten, {{documentType}} für {{asset}} zu validieren (läuft am {{expiryDate}} ab)."
      },
      "requestNoRequesterNoExpiry": {
        "title": "„{{document}}“ validieren",
        "body": "Eine Kollegin oder ein Kollege hat Sie gebeten, {{documentType}} für {{asset}} zu validieren."
      },
      "requestNoAssetNoExpiry": {
        "title": "„{{document}}“ validieren",
        "body": "{{requester}} hat Sie gebeten, {{documentType}} für eine Anlage zu validieren."
      },
      "requestNoExpiry": {
        "title": "„{{document}}“ validieren",
        "body": "{{requester}} hat Sie gebeten, {{documentType}} für {{asset}} zu validieren."
      },
      "uploadedByYou": {
        "title": "„{{document}}“ validieren",
        "body": "Sie haben {{documentType}} für {{asset}} hochgeladen (läuft am {{expiryDate}} ab)."
      },
      "uploadedByColleague": {
        "title": "„{{document}}“ validieren",
        "body": "Eine Kollegin oder ein Kollege hat {{documentType}} für {{asset}} hochgeladen (läuft am {{expiryDate}} ab)."
      },
      "uploaded": {
        "title": "„{{document}}“ validieren",
        "body": "{{uploader}} hat {{documentType}} für {{asset}} hochgeladen (läuft am {{expiryDate}} ab)."
      },
      "uploadedByYouNoExpiry": {
        "title": "„{{document}}“ validieren",
        "body": "Sie haben {{documentType}} für {{asset}} hochgeladen."
      },
      "uploadedByColleagueNoExpiry": {
        "title": "„{{document}}“ validieren",
        "body": "Eine Kollegin oder ein Kollege hat {{documentType}} für {{asset}} hochgeladen."
      },
      "uploadedNoExpiry": {
        "title": "„{{document}}“ validieren",
        "body": "{{uploader}} hat {{documentType}} für {{asset}} hochgeladen."
      }
    },
    "draft_created": {
      "noAssetLegacy": {
        "title": "Inspektionsentwurf erstellt",
        "body": "Die geplante Inspektion für eine Anlage - {{template}} ist bereit zur Durchführung."
      },
      "noAsset": {
        "title": "Inspektionsentwurf erstellt",
        "body": "Die geplante Inspektion für eine Anlage - {{template}} ist bereit zur Durchführung."
      },
      "default": {
        "title": "Inspektionsentwurf erstellt",
        "body": "Die geplante Inspektion für {{asset}} - {{template}} ist bereit zur Durchführung."
      }
    },
    "evidence_requested": {
      "noActorNoJobLegacy": {
        "title": "Weitere Nachweise für Ihren Auftrag nötig",
        "body": "Die prüfende Person hat weitere Nachweise zu einem Auftrag angefordert. {{reason}}"
      },
      "noActorNoJob": {
        "title": "Weitere Nachweise für Ihren Auftrag nötig",
        "body": "Die prüfende Person hat weitere Nachweise zu einem Auftrag angefordert. {{reason}}"
      },
      "noActorNoJobNoReasonLegacy": {
        "title": "Weitere Nachweise für Ihren Auftrag nötig",
        "body": "Die prüfende Person hat weitere Nachweise zu einem Auftrag angefordert."
      },
      "noActorNoJobNoReason": {
        "title": "Weitere Nachweise für Ihren Auftrag nötig",
        "body": "Die prüfende Person hat weitere Nachweise zu einem Auftrag angefordert."
      },
      "noActor": {
        "title": "Weitere Nachweise für Ihren Auftrag nötig",
        "body": "Die prüfende Person hat weitere Nachweise zu „{{job}}“ angefordert. {{reason}}"
      },
      "noActorNoReason": {
        "title": "Weitere Nachweise für Ihren Auftrag nötig",
        "body": "Die prüfende Person hat weitere Nachweise zu „{{job}}“ angefordert."
      },
      "noJobLegacy": {
        "title": "Weitere Nachweise für Ihren Auftrag nötig",
        "body": "{{actor}} hat weitere Nachweise zu einem Auftrag angefordert. {{reason}}"
      },
      "noJob": {
        "title": "Weitere Nachweise für Ihren Auftrag nötig",
        "body": "{{actor}} hat weitere Nachweise zu einem Auftrag angefordert. {{reason}}"
      },
      "noJobNoReasonLegacy": {
        "title": "Weitere Nachweise für Ihren Auftrag nötig",
        "body": "{{actor}} hat weitere Nachweise zu einem Auftrag angefordert."
      },
      "noJobNoReason": {
        "title": "Weitere Nachweise für Ihren Auftrag nötig",
        "body": "{{actor}} hat weitere Nachweise zu einem Auftrag angefordert."
      },
      "default": {
        "title": "Weitere Nachweise für Ihren Auftrag nötig",
        "body": "{{actor}} hat weitere Nachweise zu „{{job}}“ angefordert. {{reason}}"
      },
      "noReason": {
        "title": "Weitere Nachweise für Ihren Auftrag nötig",
        "body": "{{actor}} hat weitere Nachweise zu „{{job}}“ angefordert."
      }
    },
    "free_period_ending": {
      "ended": {
        "title": "Ihr kostenloser Zeitraum ist abgelaufen",
        "body": "Ihr Arbeitsbereich ist jetzt schreibgeschützt. Wählen Sie einen Plan, um weiterzuarbeiten. Es wurde nichts gelöscht."
      },
      "tomorrow": {
        "title": "Ihr kostenloser Zeitraum endet morgen",
        "body": "Wählen Sie vor dem {{endDate}} einen Plan, um weiterhin Inhalte hinzuzufügen und zu bearbeiten. In keinem Fall wird etwas gelöscht."
      },
      "inDays": {
        "title": "Ihr kostenloser Zeitraum endet in {{daysLeft}} Tagen",
        "body": "Wählen Sie vor dem {{endDate}} einen Plan, um weiterhin Inhalte hinzuzufügen und zu bearbeiten. In keinem Fall wird etwas gelöscht."
      }
    },
    "inspection_approved": {
      "noActorNoAsset": {
        "title": "Ihre Inspektion wurde genehmigt",
        "body": "Die genehmigende Person hat Ihre Inspektion an einer Anlage genehmigt."
      },
      "noActor": {
        "title": "Ihre Inspektion wurde genehmigt",
        "body": "Die genehmigende Person hat Ihre Inspektion an {{asset}} genehmigt."
      },
      "noAsset": {
        "title": "Ihre Inspektion wurde genehmigt",
        "body": "{{actor}} hat Ihre Inspektion an einer Anlage genehmigt."
      },
      "default": {
        "title": "Ihre Inspektion wurde genehmigt",
        "body": "{{actor}} hat Ihre Inspektion an {{asset}} genehmigt."
      }
    },
    "inspection_assigned": {
      "scheduledByActorNoTemplateNoAsset": {
        "title": "Inspektion Ihnen zugewiesen",
        "body": "{{actor}} hat Ihnen eine Inspektion an einer Anlage zugewiesen · {{when}}."
      },
      "byActorNoTemplateNoAsset": {
        "title": "Inspektion Ihnen zugewiesen",
        "body": "{{actor}} hat Ihnen eine Inspektion an einer Anlage zugewiesen."
      },
      "scheduledByActorNoTemplate": {
        "title": "Inspektion Ihnen zugewiesen",
        "body": "{{actor}} hat Ihnen eine Inspektion an {{asset}} zugewiesen · {{when}}."
      },
      "byActorNoTemplate": {
        "title": "Inspektion Ihnen zugewiesen",
        "body": "{{actor}} hat Ihnen eine Inspektion an {{asset}} zugewiesen."
      },
      "scheduledByActorNoAsset": {
        "title": "Inspektion Ihnen zugewiesen",
        "body": "{{actor}} hat Ihnen „{{template}}“ an einer Anlage zugewiesen · {{when}}."
      },
      "byActorNoAsset": {
        "title": "Inspektion Ihnen zugewiesen",
        "body": "{{actor}} hat Ihnen „{{template}}“ an einer Anlage zugewiesen."
      },
      "scheduledNoTemplateNoAsset": {
        "title": "Inspektion Ihnen zugewiesen",
        "body": "Inspektion · Eine Anlage · {{when}}."
      },
      "scheduledByActor": {
        "title": "Inspektion Ihnen zugewiesen",
        "body": "{{actor}} hat Ihnen „{{template}}“ an {{asset}} zugewiesen · {{when}}."
      },
      "noTemplateNoAsset": {
        "title": "Inspektion Ihnen zugewiesen",
        "body": "Inspektion · Eine Anlage."
      },
      "byActor": {
        "title": "Inspektion Ihnen zugewiesen",
        "body": "{{actor}} hat Ihnen „{{template}}“ an {{asset}} zugewiesen."
      },
      "scheduledNoTemplate": {
        "title": "Inspektion Ihnen zugewiesen",
        "body": "Inspektion · {{asset}} · {{when}}."
      },
      "scheduledNoAsset": {
        "title": "Inspektion Ihnen zugewiesen",
        "body": "{{template}} · Eine Anlage · {{when}}."
      },
      "noTemplate": {
        "title": "Inspektion Ihnen zugewiesen",
        "body": "Inspektion · {{asset}}."
      },
      "noAsset": {
        "title": "Inspektion Ihnen zugewiesen",
        "body": "{{template}} · Eine Anlage."
      },
      "scheduled": {
        "title": "Inspektion Ihnen zugewiesen",
        "body": "{{template}} · {{asset}} · {{when}}."
      },
      "default": {
        "title": "Inspektion Ihnen zugewiesen",
        "body": "{{template}} · {{asset}}."
      }
    },
    "inspection_completed_for_approval": {
      "noActorNoAsset": {
        "title": "Inspektion wartet auf Ihre Genehmigung",
        "body": "Eine Kollegin oder ein Kollege hat eine Inspektion an einer Anlage abgeschlossen. Prüfen und genehmigen Sie sie."
      },
      "noActor": {
        "title": "Inspektion wartet auf Ihre Genehmigung",
        "body": "Eine Kollegin oder ein Kollege hat eine Inspektion an {{asset}} abgeschlossen. Prüfen und genehmigen Sie sie."
      },
      "noAsset": {
        "title": "Inspektion wartet auf Ihre Genehmigung",
        "body": "{{actor}} hat eine Inspektion an einer Anlage abgeschlossen. Prüfen und genehmigen Sie sie."
      },
      "default": {
        "title": "Inspektion wartet auf Ihre Genehmigung",
        "body": "{{actor}} hat eine Inspektion an {{asset}} abgeschlossen. Prüfen und genehmigen Sie sie."
      }
    },
    "inspection_reassigned": {
      "inspectionNoAsset": {
        "title": "Inspektion neu zugewiesen",
        "body": "Sie sind der Inspektion für diese Anlage nicht mehr zugewiesen."
      },
      "inspection": {
        "title": "Inspektion neu zugewiesen",
        "body": "Sie sind der Inspektion für {{asset}} nicht mehr zugewiesen."
      },
      "scheduleNoAsset": {
        "title": "Inspektion neu zugewiesen",
        "body": "Sie sind dieser Inspektion nicht mehr zugewiesen."
      },
      "schedule": {
        "title": "Inspektion neu zugewiesen",
        "body": "Sie sind der geplanten Inspektion für {{asset}} nicht mehr zugewiesen."
      }
    },
    "inspection_reopened": {
      "noActorNoAsset": {
        "title": "Ihre Inspektion wurde wieder geöffnet",
        "body": "Eine Kollegin oder ein Kollege hat Ihre Inspektion an einer Anlage wieder geöffnet."
      },
      "noActor": {
        "title": "Ihre Inspektion wurde wieder geöffnet",
        "body": "Eine Kollegin oder ein Kollege hat Ihre Inspektion an {{asset}} wieder geöffnet."
      },
      "noAsset": {
        "title": "Ihre Inspektion wurde wieder geöffnet",
        "body": "{{actor}} hat Ihre Inspektion an einer Anlage wieder geöffnet."
      },
      "default": {
        "title": "Ihre Inspektion wurde wieder geöffnet",
        "body": "{{actor}} hat Ihre Inspektion an {{asset}} wieder geöffnet."
      }
    },
    "inspection_report_shared": {
      "recipientNoSharerNoAsset": {
        "title": "Inspektionsbericht bereit",
        "body": "Der Inspektor hat den Inspektionsbericht für eine Anlage geteilt. Prüfen Sie ihn und nehmen Sie ihn ab."
      },
      "recipientNoSharer": {
        "title": "Inspektionsbericht bereit",
        "body": "Der Inspektor hat den Inspektionsbericht für {{asset}} geteilt. Prüfen Sie ihn und nehmen Sie ihn ab."
      },
      "recipientNoAsset": {
        "title": "Inspektionsbericht bereit",
        "body": "{{sharer}} hat den Inspektionsbericht für eine Anlage geteilt. Prüfen Sie ihn und nehmen Sie ihn ab."
      },
      "recipient": {
        "title": "Inspektionsbericht bereit",
        "body": "{{sharer}} hat den Inspektionsbericht für {{asset}} geteilt. Prüfen Sie ihn und nehmen Sie ihn ab."
      },
      "sharerNoRecipient": {
        "title": "Inspektionsbericht geteilt",
        "body": "Prüflink für den Empfänger bereit."
      },
      "resentNoRecipient": {
        "title": "Inspektionsbericht erneut gesendet",
        "body": "Erneut an den Empfänger gesendet."
      },
      "sharer": {
        "title": "Inspektionsbericht geteilt",
        "body": "Prüflink für {{recipient}} bereit."
      },
      "sharerBlankName": {
        "title": "Inspektionsbericht geteilt",
        "body": "Der Prüflink ist bereit."
      },
      "resentBlankName": {
        "title": "Inspektionsbericht erneut gesendet",
        "body": "Berichtslink aktualisiert."
      },
      "resent": {
        "title": "Inspektionsbericht erneut gesendet",
        "body": "Erneut an {{recipient}} gesendet."
      }
    },
    "inspection_sent_back": {
      "noActorNoAsset": {
        "title": "Ihre Inspektion wurde zurückgesendet",
        "body": "Die genehmigende Person hat Ihre Inspektion an einer Anlage zurückgesendet: {{reason}}"
      },
      "noActor": {
        "title": "Ihre Inspektion wurde zurückgesendet",
        "body": "Die genehmigende Person hat Ihre Inspektion an {{asset}} zurückgesendet: {{reason}}"
      },
      "noAsset": {
        "title": "Ihre Inspektion wurde zurückgesendet",
        "body": "{{actor}} hat Ihre Inspektion an einer Anlage zurückgesendet: {{reason}}"
      },
      "default": {
        "title": "Ihre Inspektion wurde zurückgesendet",
        "body": "{{actor}} hat Ihre Inspektion an {{asset}} zurückgesendet: {{reason}}"
      }
    },
    "inspection_unassigned": {
      "inspectionNoAsset": {
        "title": "Inspektionszuweisung aufgehoben",
        "body": "Sie sind der Inspektion für diese Anlage nicht mehr zugewiesen."
      },
      "inspection": {
        "title": "Inspektionszuweisung aufgehoben",
        "body": "Sie sind der Inspektion für {{asset}} nicht mehr zugewiesen."
      },
      "scheduleNoAsset": {
        "title": "Inspektionszuweisung aufgehoben",
        "body": "Sie sind dieser Inspektion nicht mehr zugewiesen."
      },
      "schedule": {
        "title": "Inspektionszuweisung aufgehoben",
        "body": "Sie sind der geplanten Inspektion für {{asset}} nicht mehr zugewiesen."
      }
    },
    "inspection_visit_proposed": {
      "noInspection": {
        "title": "Besuchszeit bestätigen",
        "body": "Eine Inspektion ist für {{when}} geplant – bestätigen Sie, dass jemand da ist, oder bitten Sie um eine andere Zeit."
      },
      "default": {
        "title": "Besuchszeit bestätigen",
        "body": "{{inspection}} ist für {{when}} geplant – bestätigen Sie, dass jemand da ist, oder bitten Sie um eine andere Zeit."
      }
    },
    "job_accepted": {
      "noActorNoJobLegacy": {
        "title": "Auftrag angenommen",
        "body": "Die zuständige Person hat einen Auftrag angenommen."
      },
      "noActorNoJob": {
        "title": "Auftrag angenommen",
        "body": "Die zuständige Person hat einen Auftrag angenommen."
      },
      "noActor": {
        "title": "Auftrag angenommen",
        "body": "Die zuständige Person hat „{{job}}“ angenommen."
      },
      "noJobLegacy": {
        "title": "Auftrag angenommen",
        "body": "{{actor}} hat einen Auftrag angenommen."
      },
      "noJob": {
        "title": "Auftrag angenommen",
        "body": "{{actor}} hat einen Auftrag angenommen."
      },
      "default": {
        "title": "Auftrag angenommen",
        "body": "{{actor}} hat „{{job}}“ angenommen."
      }
    },
    "job_approver_assigned": {
      "noJob": {
        "title": "Genehmigungsverantwortung zugewiesen",
        "body": "Ein Auftrag wird Ihre Prüfung erfordern."
      },
      "default": {
        "title": "Genehmigungsverantwortung zugewiesen",
        "body": "{{job}} wird Ihre Prüfung erfordern."
      }
    },
    "job_approver_removed": {
      "noJobLegacy": {
        "title": "Genehmigungsverantwortung geändert",
        "body": "Sie sind nicht mehr die genehmigende Person für einen Auftrag."
      },
      "noJob": {
        "title": "Genehmigungsverantwortung geändert",
        "body": "Sie sind nicht mehr die genehmigende Person für einen Auftrag."
      },
      "default": {
        "title": "Genehmigungsverantwortung geändert",
        "body": "Sie sind nicht mehr die genehmigende Person für {{job}}."
      }
    },
    "job_assigned": {
      "byActorNoJobLegacy": {
        "title": "Auftrag Ihnen zugewiesen",
        "body": "{{actor}} hat Ihnen einen Auftrag zugewiesen · {{asset}} · fällig am {{dueDate}}."
      },
      "byActorNoJob": {
        "title": "Auftrag Ihnen zugewiesen",
        "body": "{{actor}} hat Ihnen einen Auftrag zugewiesen · {{asset}} · fällig am {{dueDate}}."
      },
      "byActorNoJobNoAssetLegacy": {
        "title": "Auftrag Ihnen zugewiesen",
        "body": "{{actor}} hat Ihnen einen Auftrag zugewiesen · fällig am {{dueDate}}."
      },
      "byActorNoJobNoAsset": {
        "title": "Auftrag Ihnen zugewiesen",
        "body": "{{actor}} hat Ihnen einen Auftrag zugewiesen · fällig am {{dueDate}}."
      },
      "byActor": {
        "title": "Auftrag Ihnen zugewiesen",
        "body": "{{actor}} hat Ihnen „{{job}}“ zugewiesen · {{asset}} · fällig am {{dueDate}}."
      },
      "byActorNoJobNoDueLegacy": {
        "title": "Auftrag Ihnen zugewiesen",
        "body": "{{actor}} hat Ihnen einen Auftrag zugewiesen · {{asset}}."
      },
      "byActorNoJobNoDue": {
        "title": "Auftrag Ihnen zugewiesen",
        "body": "{{actor}} hat Ihnen einen Auftrag zugewiesen · {{asset}}."
      },
      "byActorNoAsset": {
        "title": "Auftrag Ihnen zugewiesen",
        "body": "{{actor}} hat Ihnen „{{job}}“ zugewiesen · fällig am {{dueDate}}."
      },
      "byActorNoJobNoAssetNoDueLegacy": {
        "title": "Auftrag Ihnen zugewiesen",
        "body": "{{actor}} hat Ihnen einen Auftrag zugewiesen."
      },
      "byActorNoJobNoAssetNoDue": {
        "title": "Auftrag Ihnen zugewiesen",
        "body": "{{actor}} hat Ihnen einen Auftrag zugewiesen."
      },
      "byActorNoDue": {
        "title": "Auftrag Ihnen zugewiesen",
        "body": "{{actor}} hat Ihnen „{{job}}“ zugewiesen · {{asset}}."
      },
      "byActorNoAssetNoDue": {
        "title": "Auftrag Ihnen zugewiesen",
        "body": "{{actor}} hat Ihnen „{{job}}“ zugewiesen."
      },
      "noJob": {
        "title": "Auftrag Ihnen zugewiesen",
        "body": "Ein Auftrag · {{asset}} · fällig am {{dueDate}}."
      },
      "noJobNoAsset": {
        "title": "Auftrag Ihnen zugewiesen",
        "body": "Ein Auftrag · fällig am {{dueDate}}."
      },
      "default": {
        "title": "Auftrag Ihnen zugewiesen",
        "body": "{{job}} · {{asset}} · fällig am {{dueDate}}."
      },
      "noJobNoDue": {
        "title": "Auftrag Ihnen zugewiesen",
        "body": "Ein Auftrag · {{asset}}."
      },
      "noAsset": {
        "title": "Auftrag Ihnen zugewiesen",
        "body": "{{job}} · fällig am {{dueDate}}."
      },
      "noJobNoAssetNoDue": {
        "title": "Auftrag Ihnen zugewiesen",
        "body": "Ein Auftrag."
      },
      "noDue": {
        "title": "Auftrag Ihnen zugewiesen",
        "body": "{{job}} · {{asset}}."
      },
      "noAssetNoDue": {
        "title": "Auftrag Ihnen zugewiesen",
        "body": "{{job}}."
      }
    },
    "job_cancelled": {
      "noActorNoJobLegacy": {
        "title": "Auftrag abgebrochen",
        "body": "Eine Kollegin oder ein Kollege hat einen Auftrag an {{asset}} abgebrochen."
      },
      "noActorNoJob": {
        "title": "Auftrag abgebrochen",
        "body": "Eine Kollegin oder ein Kollege hat einen Auftrag an {{asset}} abgebrochen."
      },
      "noActorNoJobNoAssetLegacy": {
        "title": "Auftrag abgebrochen",
        "body": "Eine Kollegin oder ein Kollege hat einen Auftrag abgebrochen."
      },
      "noActorNoJobNoAsset": {
        "title": "Auftrag abgebrochen",
        "body": "Eine Kollegin oder ein Kollege hat einen Auftrag abgebrochen."
      },
      "noActor": {
        "title": "Auftrag abgebrochen",
        "body": "Eine Kollegin oder ein Kollege hat „{{job}}“ an {{asset}} abgebrochen."
      },
      "noActorNoAsset": {
        "title": "Auftrag abgebrochen",
        "body": "Eine Kollegin oder ein Kollege hat „{{job}}“ abgebrochen."
      },
      "noJobLegacy": {
        "title": "Auftrag abgebrochen",
        "body": "{{actor}} hat einen Auftrag an {{asset}} abgebrochen."
      },
      "noJob": {
        "title": "Auftrag abgebrochen",
        "body": "{{actor}} hat einen Auftrag an {{asset}} abgebrochen."
      },
      "noJobNoAssetLegacy": {
        "title": "Auftrag abgebrochen",
        "body": "{{actor}} hat einen Auftrag abgebrochen."
      },
      "noJobNoAsset": {
        "title": "Auftrag abgebrochen",
        "body": "{{actor}} hat einen Auftrag abgebrochen."
      },
      "default": {
        "title": "Auftrag abgebrochen",
        "body": "{{actor}} hat „{{job}}“ an {{asset}} abgebrochen."
      },
      "noAsset": {
        "title": "Auftrag abgebrochen",
        "body": "{{actor}} hat „{{job}}“ abgebrochen."
      }
    },
    "job_completion_approved": {
      "noRequesterNoJob": {
        "title": "Abschluss genehmigt",
        "body": "Die anfragende Person hat den Abschluss des Auftrags genehmigt."
      },
      "noRequester": {
        "title": "Abschluss genehmigt",
        "body": "Die anfragende Person hat den Abschluss von {{job}} genehmigt."
      },
      "noJob": {
        "title": "Abschluss genehmigt",
        "body": "{{requester}} hat den Abschluss des Auftrags genehmigt."
      },
      "default": {
        "title": "Abschluss genehmigt",
        "body": "{{requester}} hat den Abschluss von {{job}} genehmigt."
      }
    },
    "job_declined": {
      "noActorNoJobLegacy": {
        "title": "Auftrag abgelehnt – neu zuweisen",
        "body": "Die zuständige Person hat einen Auftrag abgelehnt. Grund: {{reason}}. Weisen Sie ihn jemand anderem zu, damit es weitergeht."
      },
      "noActorNoJob": {
        "title": "Auftrag abgelehnt – neu zuweisen",
        "body": "Die zuständige Person hat einen Auftrag abgelehnt. Grund: {{reason}} Weisen Sie ihn jemand anderem zu, damit es weitergeht."
      },
      "noActor": {
        "title": "Auftrag abgelehnt – neu zuweisen",
        "body": "Die zuständige Person hat „{{job}}“ abgelehnt. Grund: {{reason}} Weisen Sie den Auftrag jemand anderem zu, damit es weitergeht."
      },
      "noActorNoJobNoReasonLegacy": {
        "title": "Auftrag abgelehnt – neu zuweisen",
        "body": "Die zuständige Person hat einen Auftrag abgelehnt. Weisen Sie ihn jemand anderem zu, damit es weitergeht."
      },
      "noActorNoJobNoReason": {
        "title": "Auftrag abgelehnt – neu zuweisen",
        "body": "Die zuständige Person hat einen Auftrag abgelehnt. Weisen Sie ihn jemand anderem zu, damit es weitergeht."
      },
      "noJobLegacy": {
        "title": "Auftrag abgelehnt – neu zuweisen",
        "body": "{{actor}} hat einen Auftrag abgelehnt. Grund: {{reason}}. Weisen Sie ihn jemand anderem zu, damit es weitergeht."
      },
      "noJob": {
        "title": "Auftrag abgelehnt – neu zuweisen",
        "body": "{{actor}} hat einen Auftrag abgelehnt. Grund: {{reason}} Weisen Sie ihn jemand anderem zu, damit es weitergeht."
      },
      "noActorNoReason": {
        "title": "Auftrag abgelehnt – neu zuweisen",
        "body": "Die zuständige Person hat „{{job}}“ abgelehnt. Weisen Sie den Auftrag jemand anderem zu, damit es weitergeht."
      },
      "default": {
        "title": "Auftrag abgelehnt – neu zuweisen",
        "body": "{{actor}} hat „{{job}}“ abgelehnt. Grund: {{reason}} Weisen Sie den Auftrag jemand anderem zu, damit es weitergeht."
      },
      "noJobNoReasonLegacy": {
        "title": "Auftrag abgelehnt – neu zuweisen",
        "body": "{{actor}} hat einen Auftrag abgelehnt. Weisen Sie ihn jemand anderem zu, damit es weitergeht."
      },
      "noJobNoReason": {
        "title": "Auftrag abgelehnt – neu zuweisen",
        "body": "{{actor}} hat einen Auftrag abgelehnt. Weisen Sie ihn jemand anderem zu, damit es weitergeht."
      },
      "noReason": {
        "title": "Auftrag abgelehnt – neu zuweisen",
        "body": "{{actor}} hat „{{job}}“ abgelehnt. Weisen Sie den Auftrag jemand anderem zu, damit es weitergeht."
      }
    },
    "job_message": {
      "photoNoSenderLegacy": {
        "title": "Neue Nachricht zum Auftrag.",
        "body": "Jemand hat ein Foto geteilt."
      },
      "photoNoSender": {
        "title": "Neue Nachricht zum Auftrag.",
        "body": "Jemand hat ein Foto geteilt."
      },
      "photoLegacy": {
        "title": "Neue Nachricht zum Auftrag.",
        "body": "{{sender}} hat ein Foto geteilt."
      },
      "photo": {
        "title": "Neue Nachricht zum Auftrag.",
        "body": "{{sender}} hat ein Foto geteilt."
      },
      "emptyUpdateNoSender": {
        "title": "Neue Nachricht zum Auftrag",
        "body": "Jemand: Aktualisierung"
      },
      "noSender": {
        "title": "Neue Nachricht zum Auftrag",
        "body": "Jemand: {{message}}"
      },
      "emptyUpdate": {
        "title": "Neue Nachricht zum Auftrag",
        "body": "{{sender}}: Aktualisierung"
      },
      "default": {
        "title": "Neue Nachricht zum Auftrag",
        "body": "{{sender}}: {{message}}"
      }
    },
    "job_reassigned": {
      "noJobLegacy": {
        "title": "Auftrag neu zugewiesen",
        "body": "Sie sind einem Auftrag nicht mehr zugewiesen."
      },
      "noJob": {
        "title": "Auftrag neu zugewiesen",
        "body": "Sie sind einem Auftrag nicht mehr zugewiesen."
      },
      "default": {
        "title": "Auftrag neu zugewiesen",
        "body": "Sie sind dem Auftrag {{job}} nicht mehr zugewiesen."
      }
    },
    "job_report_shared": {
      "recipientNoSharerNoJobNoAssetLegacy": {
        "title": "Auftragsbericht bereit",
        "body": "Das Team hat den Abschlussbericht für einen Auftrag an einer Anlage geteilt."
      },
      "recipientNoSharerNoJobNoAsset": {
        "title": "Auftragsbericht bereit",
        "body": "Das Team hat den Abschlussbericht für einen Auftrag an einer Anlage geteilt."
      },
      "recipientNoSharerNoAsset": {
        "title": "Auftragsbericht bereit",
        "body": "Das Team hat den Abschlussbericht für „{{job}}“ an einer Anlage geteilt."
      },
      "recipientNoJobNoAssetLegacy": {
        "title": "Auftragsbericht bereit",
        "body": "{{sharer}} hat den Abschlussbericht für einen Auftrag an einer Anlage geteilt."
      },
      "recipientNoJobNoAsset": {
        "title": "Auftragsbericht bereit",
        "body": "{{sharer}} hat den Abschlussbericht für einen Auftrag an einer Anlage geteilt."
      },
      "recipientNoSharerNoJobLegacy": {
        "title": "Auftragsbericht bereit",
        "body": "Das Team hat den Abschlussbericht für einen Auftrag an {{asset}} geteilt."
      },
      "recipientNoSharerNoJob": {
        "title": "Auftragsbericht bereit",
        "body": "Das Team hat den Abschlussbericht für einen Auftrag an {{asset}} geteilt."
      },
      "recipientNoAsset": {
        "title": "Auftragsbericht bereit",
        "body": "{{sharer}} hat den Abschlussbericht für „{{job}}“ an einer Anlage geteilt."
      },
      "recipientNoSharer": {
        "title": "Auftragsbericht bereit",
        "body": "Das Team hat den Abschlussbericht für „{{job}}“ an {{asset}} geteilt."
      },
      "recipientNoJobLegacy": {
        "title": "Auftragsbericht bereit",
        "body": "{{sharer}} hat den Abschlussbericht für einen Auftrag an {{asset}} geteilt."
      },
      "recipientNoJob": {
        "title": "Auftragsbericht bereit",
        "body": "{{sharer}} hat den Abschlussbericht für einen Auftrag an {{asset}} geteilt."
      },
      "sharerNoRecipient": {
        "title": "Auftragsabschlussbericht geteilt",
        "body": "Berichtslink an den Empfänger gesendet."
      },
      "recipient": {
        "title": "Auftragsbericht bereit",
        "body": "{{sharer}} hat den Abschlussbericht für „{{job}}“ an {{asset}} geteilt."
      },
      "resentNoRecipient": {
        "title": "Auftragsabschlussbericht erneut gesendet",
        "body": "Erneut an den Empfänger gesendet."
      },
      "sharer": {
        "title": "Auftragsabschlussbericht geteilt",
        "body": "Berichtslink an {{recipient}} gesendet."
      },
      "sharerBlankName": {
        "title": "Auftragsabschlussbericht geteilt",
        "body": "Der Berichtslink ist bereit."
      },
      "resentBlankName": {
        "title": "Auftragsabschlussbericht erneut gesendet",
        "body": "Berichtslink aktualisiert."
      },
      "resent": {
        "title": "Auftragsabschlussbericht erneut gesendet",
        "body": "Erneut an {{recipient}} gesendet."
      }
    },
    "job_requester_accepted": {
      "verifierNoRequesterNoJob": {
        "title": "Die anfragende Person ist zufrieden – zum Schließen verifizieren",
        "body": "Die anfragende Person hat den Abschluss des Auftrags angenommen. Verifizieren Sie den Auftrag, um ihn zu schließen."
      },
      "verifierNoRequester": {
        "title": "Die anfragende Person ist zufrieden – zum Schließen verifizieren",
        "body": "Die anfragende Person hat den Abschluss von {{job}} angenommen. Verifizieren Sie den Auftrag, um ihn zu schließen."
      },
      "verifierNoJob": {
        "title": "Die anfragende Person ist zufrieden – zum Schließen verifizieren",
        "body": "{{requester}} hat den Abschluss des Auftrags angenommen. Verifizieren Sie den Auftrag, um ihn zu schließen."
      },
      "verifier": {
        "title": "Die anfragende Person ist zufrieden – zum Schließen verifizieren",
        "body": "{{requester}} hat den Abschluss von {{job}} angenommen. Verifizieren Sie den Auftrag, um ihn zu schließen."
      },
      "informedNoRequesterNoJob": {
        "title": "Die anfragende Person hat die Arbeiten angenommen",
        "body": "Die anfragende Person hat den Abschluss des Auftrags angenommen."
      },
      "informedNoRequester": {
        "title": "Die anfragende Person hat die Arbeiten angenommen",
        "body": "Die anfragende Person hat den Abschluss von {{job}} angenommen."
      },
      "informedNoJob": {
        "title": "Die anfragende Person hat die Arbeiten angenommen",
        "body": "{{requester}} hat den Abschluss des Auftrags angenommen."
      },
      "informed": {
        "title": "Die anfragende Person hat die Arbeiten angenommen",
        "body": "{{requester}} hat den Abschluss von {{job}} angenommen."
      }
    },
    "job_rework_requested": {
      "noRequesterNoJob": {
        "title": "Nachbesserung angefordert",
        "body": "Die anfragende Person hat eine Nachbesserung am Auftrag angefordert: {{note}}"
      },
      "noRequesterNoJobNoNote": {
        "title": "Nachbesserung angefordert",
        "body": "Die anfragende Person hat eine Nachbesserung am Auftrag angefordert."
      },
      "noRequester": {
        "title": "Nachbesserung angefordert",
        "body": "Die anfragende Person hat eine Nachbesserung an {{job}} angefordert: {{note}}"
      },
      "noRequesterNoNote": {
        "title": "Nachbesserung angefordert",
        "body": "Die anfragende Person hat eine Nachbesserung an {{job}} angefordert."
      },
      "noJob": {
        "title": "Nachbesserung angefordert",
        "body": "{{requester}} hat eine Nachbesserung am Auftrag angefordert: {{note}}"
      },
      "noJobNoNote": {
        "title": "Nachbesserung angefordert",
        "body": "{{requester}} hat eine Nachbesserung am Auftrag angefordert."
      },
      "default": {
        "title": "Nachbesserung angefordert",
        "body": "{{requester}} hat eine Nachbesserung an {{job}} angefordert: {{note}}"
      },
      "noNote": {
        "title": "Nachbesserung angefordert",
        "body": "{{requester}} hat eine Nachbesserung an {{job}} angefordert."
      }
    },
    "job_scheduled": {
      "noActorNoJobLegacy": {
        "title": "Besuch geplant",
        "body": "Die zuständige Person hat einen Auftrag für {{when}} eingeplant."
      },
      "noActorNoJob": {
        "title": "Besuch geplant",
        "body": "Die zuständige Person hat einen Auftrag für {{when}} eingeplant."
      },
      "noActor": {
        "title": "Besuch geplant",
        "body": "Die zuständige Person hat „{{job}}“ für {{when}} eingeplant."
      },
      "noJobLegacy": {
        "title": "Besuch geplant",
        "body": "{{actor}} hat einen Auftrag für {{when}} eingeplant."
      },
      "noJob": {
        "title": "Besuch geplant",
        "body": "{{actor}} hat einen Auftrag für {{when}} eingeplant."
      },
      "default": {
        "title": "Besuch geplant",
        "body": "{{actor}} hat „{{job}}“ für {{when}} eingeplant."
      }
    },
    "job_unassigned": {
      "noJobLegacy": {
        "title": "Auftragszuweisung aufgehoben",
        "body": "Sie sind einem Auftrag nicht mehr zugewiesen."
      },
      "noJob": {
        "title": "Auftragszuweisung aufgehoben",
        "body": "Sie sind einem Auftrag nicht mehr zugewiesen."
      },
      "default": {
        "title": "Auftragszuweisung aufgehoben",
        "body": "Sie sind dem Auftrag {{job}} nicht mehr zugewiesen."
      }
    },
    "job_verified": {
      "noActorNoJobLegacy": {
        "title": "Ihre Arbeit wurde verifiziert",
        "body": "Die verantwortliche Person hat einen Auftrag verifiziert. Der Auftrag ist geschlossen."
      },
      "noActorNoJob": {
        "title": "Ihre Arbeit wurde verifiziert",
        "body": "Die verantwortliche Person hat einen Auftrag verifiziert. Der Auftrag ist geschlossen."
      },
      "noActor": {
        "title": "Ihre Arbeit wurde verifiziert",
        "body": "Die verantwortliche Person hat „{{job}}“ verifiziert. Der Auftrag ist geschlossen."
      },
      "noJobLegacy": {
        "title": "Ihre Arbeit wurde verifiziert",
        "body": "{{actor}} hat einen Auftrag verifiziert. Der Auftrag ist geschlossen."
      },
      "noJob": {
        "title": "Ihre Arbeit wurde verifiziert",
        "body": "{{actor}} hat einen Auftrag verifiziert. Der Auftrag ist geschlossen."
      },
      "default": {
        "title": "Ihre Arbeit wurde verifiziert",
        "body": "{{actor}} hat „{{job}}“ verifiziert. Der Auftrag ist geschlossen."
      }
    },
    "job_visit_proposed": {
      "noJob": {
        "title": "Besuchszeit bestätigen",
        "body": "Ein Auftrag ist für {{when}} geplant – bestätigen Sie, dass jemand da ist, oder bitten Sie um eine andere Zeit."
      },
      "default": {
        "title": "Besuchszeit bestätigen",
        "body": "{{job}} ist für {{when}} geplant – bestätigen Sie, dass jemand da ist, oder bitten Sie um eine andere Zeit."
      }
    },
    "mcp_action_proposed": {
      "oneNoClient": {
        "title": "KI-Anfragen zur Genehmigung",
        "body": "Ein KI-Assistent möchte Folgendes tun: {{action}}. Genehmigen oder lehnen Sie es ab, bevor es abläuft."
      },
      "many": {
        "title": "KI-Anfragen zur Genehmigung",
        "body": "{{total}} Änderungen von KI-Assistenten warten auf Ihre Genehmigung."
      },
      "one": {
        "title": "KI-Anfragen zur Genehmigung",
        "body": "{{client}} möchte Folgendes tun: {{action}}. Genehmigen oder lehnen Sie es ab, bevor es abläuft."
      }
    },
    "member_removed_reassign": {
      "noLeaverNoJobLegacy": {
        "title": "Hinterlassene Arbeit neu zuweisen",
        "body": "Jemand hat das Team verlassen, ein Auftrag ist aber noch dieser Person zugewiesen. Weisen Sie ihn jemand anderem zu."
      },
      "noLeaverNoJob": {
        "title": "Hinterlassene Arbeit neu zuweisen",
        "body": "Jemand hat das Team verlassen, ein Auftrag ist aber noch dieser Person zugewiesen. Weisen Sie ihn jemand anderem zu."
      },
      "noLeaver": {
        "title": "Hinterlassene Arbeit neu zuweisen",
        "body": "Jemand hat das Team verlassen, „{{job}}“ ist aber noch dieser Person zugewiesen. Weisen Sie den Auftrag jemand anderem zu."
      },
      "noJobLegacy": {
        "title": "Hinterlassene Arbeit neu zuweisen",
        "body": "{{leaver}} hat das Team verlassen, ein Auftrag ist aber noch dieser Person zugewiesen. Weisen Sie ihn jemand anderem zu."
      },
      "noJob": {
        "title": "Hinterlassene Arbeit neu zuweisen",
        "body": "{{leaver}} hat das Team verlassen, ein Auftrag ist aber noch dieser Person zugewiesen. Weisen Sie ihn jemand anderem zu."
      },
      "default": {
        "title": "Hinterlassene Arbeit neu zuweisen",
        "body": "{{leaver}} hat das Team verlassen, „{{job}}“ ist aber noch dieser Person zugewiesen. Weisen Sie den Auftrag jemand anderem zu."
      }
    },
    "mfa_reset_requested": {
      "noMember": {
        "title": "Zurücksetzen der Zwei-Faktor-Anmeldung angefordert",
        "body": "Ein Mitglied des Arbeitsbereichs ist von der Zwei-Faktor-Anmeldung ausgesperrt und hat um ein Zurücksetzen gebeten."
      },
      "default": {
        "title": "Zurücksetzen der Zwei-Faktor-Anmeldung angefordert",
        "body": "{{member}} ist von der Zwei-Faktor-Anmeldung ausgesperrt und hat um ein Zurücksetzen gebeten."
      }
    },
    "plan_changed": {
      "byActorLegacy": {
        "title": "Ihr Plan für {{day}} wurde geändert",
        "body": "{{actor}} hat {{total}} Einträge in Ihrem Tag geändert. Öffnen Sie „Mein Tag“, um die Änderungen zu sehen."
      },
      "byActor": {
        "title": "Ihr Plan für {{day}} wurde geändert",
        "body": "{{actor}} hat {{total}} Einträge in Ihrem Tag geändert. Öffnen Sie „Mein Tag“, um die Änderungen zu sehen."
      },
      "defaultLegacy": {
        "title": "Ihr Plan für {{day}} wurde geändert",
        "body": "Geändert: {{total}} Einträge in Ihrem Tag. Öffnen Sie „Mein Tag“, um die Änderungen zu sehen."
      },
      "default": {
        "title": "Ihr Plan für {{day}} wurde geändert",
        "body": "Geändert: {{total}} Einträge in Ihrem Tag. Öffnen Sie „Mein Tag“, um die Änderungen zu sehen."
      },
      "byActorOne": {
        "title": "Ihr Plan für {{day}} wurde geändert",
        "body": "{{actor}} hat {{total}} Eintrag in Ihrem Tag geändert. Öffnen Sie „Mein Tag“, um die Änderung zu sehen."
      },
      "one": {
        "title": "Ihr Plan für {{day}} wurde geändert",
        "body": "Geändert: {{total}} Eintrag in Ihrem Tag. Öffnen Sie „Mein Tag“, um die Änderung zu sehen."
      }
    },
    "plan_review": {
      "default": {
        "title": "Der Plan für {{day}} muss geprüft werden",
        "body": "Etwas in diesem Tag passt nicht mehr. Öffnen Sie den Kalender, um den vorgeschlagenen Plan zu prüfen."
      }
    },
    "quote_declined": {
      "noContractor": {
        "title": "Angebotsanfrage abgelehnt",
        "body": "Ein Auftragnehmer hat es abgelehnt, ein Angebot für {{job}} abzugeben."
      },
      "noContractorNoJob": {
        "title": "Angebotsanfrage abgelehnt",
        "body": "Ein Auftragnehmer hat es abgelehnt, ein Angebot abzugeben."
      },
      "default": {
        "title": "Angebotsanfrage abgelehnt",
        "body": "{{contractor}} hat es abgelehnt, ein Angebot für {{job}} abzugeben."
      },
      "noJob": {
        "title": "Angebotsanfrage abgelehnt",
        "body": "{{contractor}} hat es abgelehnt, ein Angebot abzugeben."
      }
    },
    "quote_rejected": {
      "noJobLegacy": {
        "title": "Angebot nicht ausgewählt",
        "body": "Ihr Angebot für einen Auftrag wurde geprüft, aber nicht ausgewählt."
      },
      "noJob": {
        "title": "Angebot nicht ausgewählt",
        "body": "Ihr Angebot für einen Auftrag wurde geprüft, aber nicht ausgewählt."
      },
      "default": {
        "title": "Angebot nicht ausgewählt",
        "body": "Ihr Angebot für „{{job}}“ wurde geprüft, aber nicht ausgewählt."
      }
    },
    "quote_requested": {
      "noJobLegacy": {
        "title": "Angebotsanfrage",
        "body": "Sie wurden eingeladen, ein Angebot für einen Auftrag abzugeben."
      },
      "noJob": {
        "title": "Angebotsanfrage",
        "body": "Sie wurden eingeladen, ein Angebot für einen Auftrag abzugeben."
      },
      "default": {
        "title": "Angebotsanfrage",
        "body": "Sie wurden eingeladen, ein Angebot abzugeben für: {{job}}."
      }
    },
    "quote_submitted": {
      "taxNoContractorNoJob": {
        "title": "Neues Angebot eingegangen",
        "body": "Ein Auftragnehmer hat {{amount}} inkl. Steuern für einen Auftrag angeboten. Prüfen Sie die Angebote."
      },
      "taxNoContractor": {
        "title": "Neues Angebot eingegangen",
        "body": "Ein Auftragnehmer hat {{amount}} inkl. Steuern für „{{job}}“ angeboten. Prüfen Sie die Angebote."
      },
      "taxNoJob": {
        "title": "Neues Angebot eingegangen",
        "body": "{{contractor}} hat {{amount}} inkl. Steuern für einen Auftrag angeboten. Prüfen Sie die Angebote."
      },
      "tax": {
        "title": "Neues Angebot eingegangen",
        "body": "{{contractor}} hat {{amount}} inkl. Steuern für „{{job}}“ angeboten. Prüfen Sie die Angebote."
      },
      "noContractorNoPriceNoJobLegacy": {
        "title": "Neues Angebot eingegangen",
        "body": "Ein Auftragnehmer hat ein Angebot für einen Auftrag abgegeben. Prüfen Sie die Angebote."
      },
      "noContractorNoPriceNoJob": {
        "title": "Neues Angebot eingegangen",
        "body": "Ein Auftragnehmer hat ein Angebot für einen Auftrag abgegeben. Prüfen Sie die Angebote."
      },
      "noContractorNoPrice": {
        "title": "Neues Angebot eingegangen",
        "body": "Ein Auftragnehmer hat ein Angebot für „{{job}}“ abgegeben. Prüfen Sie die Angebote."
      },
      "noContractorNoJobLegacy": {
        "title": "Neues Angebot eingegangen",
        "body": "Ein Auftragnehmer hat {{amount}} für einen Auftrag angeboten. Prüfen Sie die Angebote."
      },
      "noContractorNoJob": {
        "title": "Neues Angebot eingegangen",
        "body": "Ein Auftragnehmer hat {{amount}} für einen Auftrag angeboten. Prüfen Sie die Angebote."
      },
      "noPriceNoJobLegacy": {
        "title": "Neues Angebot eingegangen",
        "body": "{{contractor}} hat ein Angebot für einen Auftrag abgegeben. Prüfen Sie die Angebote."
      },
      "noPriceNoJob": {
        "title": "Neues Angebot eingegangen",
        "body": "{{contractor}} hat ein Angebot für einen Auftrag abgegeben. Prüfen Sie die Angebote."
      },
      "noContractor": {
        "title": "Neues Angebot eingegangen",
        "body": "Ein Auftragnehmer hat {{amount}} für „{{job}}“ angeboten. Prüfen Sie die Angebote."
      },
      "noPrice": {
        "title": "Neues Angebot eingegangen",
        "body": "{{contractor}} hat ein Angebot für „{{job}}“ abgegeben. Prüfen Sie die Angebote."
      },
      "noJobLegacy": {
        "title": "Neues Angebot eingegangen",
        "body": "{{contractor}} hat {{amount}} für einen Auftrag angeboten. Prüfen Sie die Angebote."
      },
      "noJob": {
        "title": "Neues Angebot eingegangen",
        "body": "{{contractor}} hat {{amount}} für einen Auftrag angeboten. Prüfen Sie die Angebote."
      },
      "default": {
        "title": "Neues Angebot eingegangen",
        "body": "{{contractor}} hat {{amount}} für „{{job}}“ angeboten. Prüfen Sie die Angebote."
      }
    },
    "report_access_declined": {
      "noAsset": {
        "title": "Berichtszugriff abgelehnt",
        "body": "Ihre Anfrage, den Bericht zur Anlage anzusehen, wurde abgelehnt."
      },
      "default": {
        "title": "Berichtszugriff abgelehnt",
        "body": "Ihre Anfrage, den Bericht zu {{asset}} anzusehen, wurde abgelehnt."
      }
    },
    "report_access_granted": {
      "noAsset": {
        "title": "Berichtszugriff genehmigt",
        "body": "Sie können den Bericht zur Anlage jetzt ansehen."
      },
      "default": {
        "title": "Berichtszugriff genehmigt",
        "body": "Sie können den Bericht zu {{asset}} jetzt ansehen."
      }
    },
    "report_access_requested": {
      "noRequesterNoAsset": {
        "title": "Berichtszugriff angefordert.",
        "body": "Jemand möchte den Bericht zu einer Anlage ansehen."
      },
      "noAsset": {
        "title": "Berichtszugriff angefordert.",
        "body": "{{requester}} möchte den Bericht zu einer Anlage ansehen."
      },
      "noRequester": {
        "title": "Berichtszugriff angefordert.",
        "body": "Jemand möchte den Bericht zu {{asset}} ansehen."
      },
      "default": {
        "title": "Berichtszugriff angefordert.",
        "body": "{{requester}} möchte den Bericht zu {{asset}} ansehen."
      },
      "noRequesterNoAssetLegacy": {
        "title": "Berichtszugriff angefordert.",
        "body": "Jemand möchte den Bericht zu einer Anlage ansehen."
      },
      "noAssetLegacy": {
        "title": "Berichtszugriff angefordert.",
        "body": "{{requester}} möchte den Bericht zu einer Anlage ansehen."
      },
      "noRequesterLegacy": {
        "title": "Berichtszugriff angefordert.",
        "body": "Jemand möchte den Bericht zu {{asset}} ansehen."
      },
      "defaultLegacy": {
        "title": "Berichtszugriff angefordert.",
        "body": "{{requester}} möchte den Bericht zu {{asset}} ansehen."
      }
    },
    "request_assigned": {
      "default": {
        "title": "Anfrage Ihnen zugewiesen",
        "body": "{{request}} wartet auf Ihre Bearbeitung."
      },
      "byActor": {
        "title": "Anfrage Ihnen zugewiesen",
        "body": "{{actor}} hat Ihnen „{{request}}“ zugewiesen."
      }
    },
    "request_reassigned": {
      "default": {
        "title": "Anfrage neu zugewiesen",
        "body": "Sie sind der Anfrage {{request}} nicht mehr zugewiesen."
      }
    },
    "request_team_assigned": {
      "noTeam": {
        "title": "Anfrage in Ihr Team verschoben",
        "body": "{{request}} wird jetzt von Ihrem Team betreut."
      },
      "default": {
        "title": "Anfrage in Ihr Team verschoben",
        "body": "{{request}} wird jetzt vom Team {{team}} betreut."
      }
    },
    "request_team_removed": {
      "default": {
        "title": "Anfrage aus Ihrem Team verschoben",
        "body": "{{request}} wird nicht mehr von Ihrem Team betreut."
      }
    },
    "rework_requested": {
      "noActorNoJobLegacy": {
        "title": "Nachbesserung an Ihrem Auftrag nötig",
        "body": "Die prüfende Person hat einen Auftrag zur Nachbesserung zurückgesendet. Grund: {{reason}}."
      },
      "noActorNoJob": {
        "title": "Nachbesserung an Ihrem Auftrag nötig",
        "body": "Die prüfende Person hat einen Auftrag zur Nachbesserung zurückgesendet. Grund: {{reason}}"
      },
      "noActor": {
        "title": "Nachbesserung an Ihrem Auftrag nötig",
        "body": "Die prüfende Person hat „{{job}}“ zur Nachbesserung zurückgesendet. Grund: {{reason}}"
      },
      "noActorNoJobNoReasonLegacy": {
        "title": "Nachbesserung an Ihrem Auftrag nötig",
        "body": "Die prüfende Person hat einen Auftrag zur Nachbesserung zurückgesendet."
      },
      "noActorNoJobNoReason": {
        "title": "Nachbesserung an Ihrem Auftrag nötig",
        "body": "Die prüfende Person hat einen Auftrag zur Nachbesserung zurückgesendet."
      },
      "noJobLegacy": {
        "title": "Nachbesserung an Ihrem Auftrag nötig",
        "body": "{{actor}} hat einen Auftrag zur Nachbesserung zurückgesendet. Grund: {{reason}}."
      },
      "noJob": {
        "title": "Nachbesserung an Ihrem Auftrag nötig",
        "body": "{{actor}} hat einen Auftrag zur Nachbesserung zurückgesendet. Grund: {{reason}}"
      },
      "noActorNoReason": {
        "title": "Nachbesserung an Ihrem Auftrag nötig",
        "body": "Die prüfende Person hat „{{job}}“ zur Nachbesserung zurückgesendet."
      },
      "default": {
        "title": "Nachbesserung an Ihrem Auftrag nötig",
        "body": "{{actor}} hat „{{job}}“ zur Nachbesserung zurückgesendet. Grund: {{reason}}"
      },
      "noJobNoReasonLegacy": {
        "title": "Nachbesserung an Ihrem Auftrag nötig",
        "body": "{{actor}} hat einen Auftrag zur Nachbesserung zurückgesendet."
      },
      "noJobNoReason": {
        "title": "Nachbesserung an Ihrem Auftrag nötig",
        "body": "{{actor}} hat einen Auftrag zur Nachbesserung zurückgesendet."
      },
      "noReason": {
        "title": "Nachbesserung an Ihrem Auftrag nötig",
        "body": "{{actor}} hat „{{job}}“ zur Nachbesserung zurückgesendet."
      }
    },
    "share_message": {
      "noSender": {
        "title": "Neue Nachricht zum Inspektionsbericht",
        "body": "Jemand: {{message}}"
      },
      "default": {
        "title": "Neue Nachricht zum Inspektionsbericht",
        "body": "{{sender}}: {{message}}"
      }
    },
    "share_response_submitted": {
      "closedOnBehalfNoActorNoRecipient": {
        "title": "Bericht ohne Antwort geschlossen",
        "body": "Das Anlagenteam hat den Bericht für {{asset}} im Namen der empfangenden Person geschlossen: {{reason}}"
      },
      "closedOnBehalfNoActorNoRecipientNoReason": {
        "title": "Bericht ohne Antwort geschlossen",
        "body": "Das Anlagenteam hat den Bericht für {{asset}} im Namen der empfangenden Person geschlossen."
      },
      "approvedOnBehalfNoActorNoRecipient": {
        "title": "Inspektionsbericht genehmigt",
        "body": "Das Anlagenteam hat den Bericht für {{asset}} im Namen der empfangenden Person abgenommen."
      },
      "closedOnBehalfNoActorNoAssetNoRecipient": {
        "title": "Bericht ohne Antwort geschlossen",
        "body": "Das Anlagenteam hat den Bericht im Namen der empfangenden Person geschlossen: {{reason}}"
      },
      "closedOnBehalfNoActorNoAssetNoRecipientNoReason": {
        "title": "Bericht ohne Antwort geschlossen",
        "body": "Das Anlagenteam hat den Bericht im Namen der empfangenden Person geschlossen."
      },
      "approvedOnBehalfNoActorNoAssetNoRecipient": {
        "title": "Inspektionsbericht genehmigt",
        "body": "Das Anlagenteam hat den Bericht im Namen der empfangenden Person abgenommen."
      },
      "closedOnBehalfNoActor": {
        "title": "Bericht ohne Antwort geschlossen",
        "body": "Das Anlagenteam hat den Bericht für {{asset}} im Namen von {{recipient}} geschlossen: {{reason}}"
      },
      "closedOnBehalfNoRecipient": {
        "title": "Bericht ohne Antwort geschlossen",
        "body": "{{actor}} hat den Bericht für {{asset}} im Namen der empfangenden Person geschlossen: {{reason}}"
      },
      "closedOnBehalfNoActorNoReason": {
        "title": "Bericht ohne Antwort geschlossen",
        "body": "Das Anlagenteam hat den Bericht für {{asset}} im Namen von {{recipient}} geschlossen."
      },
      "closedOnBehalfNoRecipientNoReason": {
        "title": "Bericht ohne Antwort geschlossen",
        "body": "{{actor}} hat den Bericht für {{asset}} im Namen der empfangenden Person geschlossen."
      },
      "approvedOnBehalfNoActor": {
        "title": "Inspektionsbericht genehmigt",
        "body": "Das Anlagenteam hat den Bericht für {{asset}} im Namen von {{recipient}} abgenommen."
      },
      "changesNoSigner": {
        "title": "Änderungen an einem Bericht angefordert",
        "body": "Die empfangende Person hat Änderungen am Bericht für {{asset}} angefordert: {{reason}}"
      },
      "approvedOnBehalfNoRecipient": {
        "title": "Inspektionsbericht genehmigt",
        "body": "{{actor}} hat den Bericht für {{asset}} im Namen der empfangenden Person abgenommen."
      },
      "changesNoSignerNoReason": {
        "title": "Änderungen an einem Bericht angefordert",
        "body": "Die empfangende Person hat Änderungen am Bericht für {{asset}} angefordert."
      },
      "closedOnBehalfNoActorNoAsset": {
        "title": "Bericht ohne Antwort geschlossen",
        "body": "Das Anlagenteam hat den Bericht im Namen von {{recipient}} geschlossen: {{reason}}"
      },
      "closedOnBehalfNoAssetNoRecipient": {
        "title": "Bericht ohne Antwort geschlossen",
        "body": "{{actor}} hat den Bericht im Namen der empfangenden Person geschlossen: {{reason}}"
      },
      "closedOnBehalfNoActorNoAssetNoReason": {
        "title": "Bericht ohne Antwort geschlossen",
        "body": "Das Anlagenteam hat den Bericht im Namen von {{recipient}} geschlossen."
      },
      "closedOnBehalfNoAssetNoRecipientNoReason": {
        "title": "Bericht ohne Antwort geschlossen",
        "body": "{{actor}} hat den Bericht im Namen der empfangenden Person geschlossen."
      },
      "approvedOnBehalfNoActorNoAsset": {
        "title": "Inspektionsbericht genehmigt",
        "body": "Das Anlagenteam hat den Bericht im Namen von {{recipient}} abgenommen."
      },
      "changesNoSignerNoAsset": {
        "title": "Änderungen an einem Bericht angefordert",
        "body": "Die empfangende Person hat Änderungen am Bericht angefordert: {{reason}}"
      },
      "approvedOnBehalfNoAssetNoRecipient": {
        "title": "Inspektionsbericht genehmigt",
        "body": "{{actor}} hat den Bericht im Namen der empfangenden Person abgenommen."
      },
      "changesNoSignerNoAssetNoReason": {
        "title": "Änderungen an einem Bericht angefordert",
        "body": "Die empfangende Person hat Änderungen am Bericht angefordert."
      },
      "closedOnBehalf": {
        "title": "Bericht ohne Antwort geschlossen",
        "body": "{{actor}} hat den Bericht für {{asset}} im Namen von {{recipient}} geschlossen: {{reason}}"
      },
      "closedOnBehalfNoReason": {
        "title": "Bericht ohne Antwort geschlossen",
        "body": "{{actor}} hat den Bericht für {{asset}} im Namen von {{recipient}} geschlossen."
      },
      "changes": {
        "title": "Änderungen an einem Bericht angefordert",
        "body": "{{signer}} hat Änderungen am Bericht für {{asset}} angefordert: {{reason}}"
      },
      "approvedNoSigner": {
        "title": "Inspektionsbericht genehmigt",
        "body": "Die empfangende Person hat den Bericht für {{asset}} abgenommen."
      },
      "approvedOnBehalf": {
        "title": "Inspektionsbericht genehmigt",
        "body": "{{actor}} hat den Bericht für {{asset}} im Namen von {{recipient}} abgenommen."
      },
      "changesNoReason": {
        "title": "Änderungen an einem Bericht angefordert",
        "body": "{{signer}} hat Änderungen am Bericht für {{asset}} angefordert."
      },
      "closedOnBehalfNoAsset": {
        "title": "Bericht ohne Antwort geschlossen",
        "body": "{{actor}} hat den Bericht im Namen von {{recipient}} geschlossen: {{reason}}"
      },
      "closedOnBehalfNoAssetNoReason": {
        "title": "Bericht ohne Antwort geschlossen",
        "body": "{{actor}} hat den Bericht im Namen von {{recipient}} geschlossen."
      },
      "changesNoAsset": {
        "title": "Änderungen an einem Bericht angefordert",
        "body": "{{signer}} hat Änderungen am Bericht angefordert: {{reason}}"
      },
      "approvedNoSignerNoAsset": {
        "title": "Inspektionsbericht genehmigt",
        "body": "Die empfangende Person hat den Bericht abgenommen."
      },
      "approvedOnBehalfNoAsset": {
        "title": "Inspektionsbericht genehmigt",
        "body": "{{actor}} hat den Bericht im Namen von {{recipient}} abgenommen."
      },
      "changesNoAssetNoReason": {
        "title": "Änderungen an einem Bericht angefordert",
        "body": "{{signer}} hat Änderungen am Bericht angefordert."
      },
      "approved": {
        "title": "Inspektionsbericht genehmigt",
        "body": "{{signer}} hat den Bericht für {{asset}} abgenommen."
      },
      "approvedNoAsset": {
        "title": "Inspektionsbericht genehmigt",
        "body": "{{signer}} hat den Bericht abgenommen."
      }
    },
    "site_team_assigned": {
      "noTeam": {
        "title": "Neuer Standort in Ihrem Team",
        "body": "{{site}} wurde Ihrem Team zugewiesen."
      },
      "default": {
        "title": "Neuer Standort in Ihrem Team",
        "body": "{{site}} wurde dem Team {{team}} zugewiesen."
      }
    },
    "site_team_removed": {
      "default": {
        "title": "Standort aus Ihrem Team verschoben",
        "body": "{{site}} ist Ihrem Team nicht mehr zugewiesen."
      }
    },
    "stalled_work_digest": {
      "many": {
        "title": "{{total}} Vorgänge warten auf jemanden",
        "body": "{{itemTitle}} · {{asset}}. {{line}} Und {{moreCount}} weitere."
      },
      "manyNoAsset": {
        "title": "{{total}} Vorgänge warten auf jemanden",
        "body": "{{itemTitle}}. {{line}} Und {{moreCount}} weitere."
      },
      "one": {
        "title": "Ein Vorgang wartet auf jemanden",
        "body": "{{itemTitle}} · {{asset}}. {{line}}"
      },
      "oneNoAsset": {
        "title": "Ein Vorgang wartet auf jemanden",
        "body": "{{itemTitle}}. {{line}}"
      }
    },
    "team_admin_approved": {
      "noMemberLegacy": {
        "title": "Ein Teammitglied ist jetzt Admin",
        "body": "Der Inhaber hat Ihre Anfrage für ein Teammitglied genehmigt."
      },
      "noMember": {
        "title": "Ein Teammitglied ist jetzt Admin",
        "body": "Der Inhaber hat Ihre Anfrage für ein Teammitglied genehmigt."
      },
      "default": {
        "title": "{{member}} ist jetzt Admin",
        "body": "Der Inhaber hat Ihre Anfrage für {{member}} genehmigt."
      }
    },
    "team_admin_declined": {
      "noMemberLegacy": {
        "title": "Admin-Anfrage abgelehnt",
        "body": "Der Inhaber hat Ihre Anfrage abgelehnt, ein Teammitglied zum Admin zu machen."
      },
      "noMember": {
        "title": "Admin-Anfrage abgelehnt",
        "body": "Der Inhaber hat Ihre Anfrage abgelehnt, ein Teammitglied zum Admin zu machen."
      },
      "default": {
        "title": "Admin-Anfrage abgelehnt",
        "body": "Der Inhaber hat Ihre Anfrage abgelehnt, {{member}} zum Admin zu machen."
      }
    },
    "team_admin_requested": {
      "noMemberNoTeamLegacy": {
        "title": "Ein Teammitglied zum Admin machen?",
        "body": "Ihr Team: Ein Admin möchte ein Teammitglied zum Admin machen."
      },
      "noMemberNoTeam": {
        "title": "Ein Teammitglied zum Admin machen?",
        "body": "Ihr Team: Ein Admin möchte ein Teammitglied zum Admin machen."
      },
      "noMemberLegacy": {
        "title": "Ein Teammitglied zum Admin machen?",
        "body": "{{team}}: Ein Admin möchte ein Teammitglied zum Admin machen."
      },
      "noMember": {
        "title": "Ein Teammitglied zum Admin machen?",
        "body": "{{team}}: Ein Admin möchte ein Teammitglied zum Admin machen."
      },
      "noTeam": {
        "title": "{{member}} zum Admin machen?",
        "body": "Ihr Team: Ein Admin möchte {{member}} zum Admin machen."
      },
      "default": {
        "title": "{{member}} zum Admin machen?",
        "body": "{{team}}: Ein Admin möchte {{member}} zum Admin machen."
      }
    },
    "team_invite_accepted": {
      "noTeam": {
        "title": "Einladung in den Arbeitsbereich angenommen",
        "body": "{{email}} hat die Einladung in Ihr Team angenommen."
      },
      "default": {
        "title": "Einladung in den Arbeitsbereich angenommen",
        "body": "{{email}} hat die Einladung in das Team {{team}} angenommen."
      }
    },
    "team_invite_declined": {
      "noTeam": {
        "title": "Einladung in den Arbeitsbereich abgelehnt",
        "body": "{{email}} hat die Einladung in Ihr Team abgelehnt."
      },
      "default": {
        "title": "Einladung in den Arbeitsbereich abgelehnt",
        "body": "{{email}} hat die Einladung in das Team {{team}} abgelehnt."
      }
    },
    "team_invited": {
      "noTeam": {
        "title": "Einladung in den Arbeitsbereich",
        "body": "Sie wurden eingeladen, einem Team im Arbeitsbereich beizutreten."
      },
      "default": {
        "title": "Einladung in den Arbeitsbereich",
        "body": "Sie wurden eingeladen, dem Team {{team}} beizutreten."
      }
    },
    "team_member_added": {
      "noTeam": {
        "title": "Zum Team im Arbeitsbereich hinzugefügt",
        "body": "Ihr Team."
      },
      "default": {
        "title": "Zum Team im Arbeitsbereich hinzugefügt",
        "body": "{{team}}."
      }
    },
    "team_member_removed": {
      "noTeam": {
        "title": "Aus dem Team im Arbeitsbereich entfernt",
        "body": "Ihr Team."
      },
      "default": {
        "title": "Aus dem Team im Arbeitsbereich entfernt",
        "body": "{{team}}."
      }
    },
    "team_member_role_changed": {
      "noTeam": {
        "title": "Rolle im Arbeitsbereich geändert",
        "body": "Ihr Team · Rolle {{role}}"
      },
      "default": {
        "title": "Rolle im Arbeitsbereich geändert",
        "body": "{{team}} · Rolle {{role}}"
      }
    },
    "team_ownership_accepted": {
      "noWorkspace": {
        "title": "Inhaberschaft des Arbeitsbereichs angenommen",
        "body": "Die Übertragung der Inhaberschaft des Arbeitsbereichs wurde angenommen."
      },
      "default": {
        "title": "Inhaberschaft des Arbeitsbereichs angenommen",
        "body": "Die Übertragung der Inhaberschaft von {{workspace}} wurde angenommen."
      }
    },
    "team_ownership_cancelled": {
      "noWorkspace": {
        "title": "Übertragung der Inhaberschaft abgebrochen",
        "body": "Die Übertragung der Inhaberschaft des Arbeitsbereichs wurde abgebrochen."
      },
      "default": {
        "title": "Übertragung der Inhaberschaft abgebrochen",
        "body": "Die Übertragung der Inhaberschaft von {{workspace}} wurde abgebrochen."
      }
    },
    "team_ownership_declined": {
      "noWorkspace": {
        "title": "Inhaberschaft des Arbeitsbereichs abgelehnt",
        "body": "Die Übertragung der Inhaberschaft des Arbeitsbereichs wurde abgelehnt."
      },
      "default": {
        "title": "Inhaberschaft des Arbeitsbereichs abgelehnt",
        "body": "Die Übertragung der Inhaberschaft von {{workspace}} wurde abgelehnt."
      }
    },
    "team_ownership_expired": {
      "noWorkspaceLegacy": {
        "title": "Übertragung der Inhaberschaft abgelaufen",
        "body": "Die Übertragung der Inhaberschaft des Arbeitsbereichs ist abgelaufen."
      },
      "noWorkspace": {
        "title": "Übertragung der Inhaberschaft abgelaufen",
        "body": "Die Übertragung der Inhaberschaft des Arbeitsbereichs ist abgelaufen."
      },
      "defaultLegacy": {
        "title": "Übertragung der Inhaberschaft abgelaufen",
        "body": "Die Übertragung der Inhaberschaft von {{workspace}} ist abgelaufen."
      },
      "default": {
        "title": "Übertragung der Inhaberschaft abgelaufen",
        "body": "Die Übertragung der Inhaberschaft von {{workspace}} ist abgelaufen."
      }
    },
    "team_ownership_requested": {
      "noWorkspace": {
        "title": "Inhaberschaft des Arbeitsbereichs angeboten",
        "body": "Ein Arbeitsbereich wartet auf Ihre Entscheidung."
      },
      "default": {
        "title": "Inhaberschaft des Arbeitsbereichs angeboten",
        "body": "{{workspace}} wartet auf Ihre Entscheidung."
      }
    },
    "work_change_approved": {
      "byPolicyNoWork": {
        "title": "Gemäß Planrichtlinie übersprungen: geplante Arbeit",
        "body": "{{reason}}"
      },
      "byPolicy": {
        "title": "Gemäß Planrichtlinie übersprungen: {{work}}",
        "body": "{{reason}}"
      },
      "decided": {
        "title": "Änderung genehmigt",
        "body": "{{action}} genehmigt"
      }
    },
    "work_change_rejected": {
      "default": {
        "title": "Änderung nicht genehmigt",
        "body": "Diese Arbeit ist weiterhin fällig"
      }
    },
    "work_change_requested": {
      "noWork": {
        "title": "Änderung angefordert: geplante Arbeit",
        "body": "{{reason}}"
      },
      "default": {
        "title": "Änderung angefordert: {{work}}",
        "body": "{{reason}}"
      }
    },
    "work_needs_assignee": {
      "raisedNoAsset": {
        "title": "Noch niemand zugewiesen",
        "body": "\"{{work}}\" ist am {{dueDate}} fällig. Weisen Sie es vorher jemandem zu."
      },
      "reminderNoAsset": {
        "title": "Immer noch niemand zugewiesen",
        "body": "\"{{work}}\" ist am {{dueDate}} fällig. Weisen Sie es jemandem zu oder erledigen Sie es selbst."
      },
      "raised": {
        "title": "Noch niemand zugewiesen",
        "body": "\"{{work}}\" · {{asset}} ist am {{dueDate}} fällig. Weisen Sie es vorher jemandem zu."
      },
      "reminder": {
        "title": "Immer noch niemand zugewiesen",
        "body": "\"{{work}}\" · {{asset}} ist am {{dueDate}} fällig. Weisen Sie es jemandem zu oder erledigen Sie es selbst."
      }
    },
    "work_rescheduled": {
      "noInspection": {
        "title": "Neu geplant",
        "body": "Inspektion · {{asset}} ist jetzt für {{when}} geplant."
      },
      "noInspectionNoAsset": {
        "title": "Neu geplant",
        "body": "Die Inspektion ist jetzt für {{when}} geplant."
      },
      "noJob": {
        "title": "Neu geplant",
        "body": "Ein Auftrag · {{asset}} ist jetzt für {{when}} geplant."
      },
      "noJobNoAsset": {
        "title": "Neu geplant",
        "body": "Ein Auftrag ist jetzt für {{when}} geplant."
      },
      "default": {
        "title": "Neu geplant",
        "body": "{{work}} · {{asset}} ist jetzt für {{when}} geplant."
      },
      "noAsset": {
        "title": "Neu geplant",
        "body": "{{work}} ist jetzt für {{when}} geplant."
      }
    },
    "work_unscheduled": {
      "noInspection": {
        "title": "Nicht mehr geplant",
        "body": "Inspektion · {{asset}} ist nicht mehr geplant."
      },
      "noInspectionNoAsset": {
        "title": "Nicht mehr geplant",
        "body": "Die Inspektion ist nicht mehr geplant."
      },
      "noJob": {
        "title": "Nicht mehr geplant",
        "body": "Ein Auftrag · {{asset}} ist nicht mehr geplant."
      },
      "noJobNoAsset": {
        "title": "Nicht mehr geplant",
        "body": "Ein Auftrag ist nicht mehr geplant."
      },
      "default": {
        "title": "Nicht mehr geplant",
        "body": "{{work}} · {{asset}} ist nicht mehr geplant."
      },
      "noAsset": {
        "title": "Nicht mehr geplant",
        "body": "{{work}} ist nicht mehr geplant."
      }
    },
    "esg_certificate_expiring": {
      "expired": {
        "title": "Energieausweis abgelaufen: {{place}}",
        "body": "Der {{scheme}} (Klasse {{rating}}) läuft am {{endDate}} ab. Buchen Sie eine neue Bewertung, damit vermietet oder verkauft werden kann."
      },
      "inDays": {
        "title": "Energieausweis läuft in {{daysLeft}} Tagen ab: {{place}}",
        "body": "Der {{scheme}} (Klasse {{rating}}) läuft am {{endDate}} ab. Buchen Sie eine neue Bewertung, damit vermietet oder verkauft werden kann."
      }
    }
  },
  "lines": {
    "shareNotAcceptedOne": "{{waitingOn}} hat den Zugriff auf diese Anlage seit {{days}} Tag nicht angenommen. Haken Sie nach oder entfernen Sie die Freigabe.",
    "shareNotAccepted": "{{waitingOn}} hat den Zugriff auf diese Anlage seit {{days}} Tagen nicht angenommen. Haken Sie nach oder entfernen Sie die Freigabe.",
    "expiredNotRenewedOne": "Vor {{days}} Tag abgelaufen und von niemandem erneuert.",
    "expiredNotRenewed": "Vor {{days}} Tagen abgelaufen und von niemandem erneuert.",
    "fixNotConfirmedOne": "{{waitingOn}} hat die Behebung seit {{days}} Tag nicht bestätigt. Haken Sie nach.",
    "fixNotConfirmed": "{{waitingOn}} hat die Behebung seit {{days}} Tagen nicht bestätigt. Haken Sie nach.",
    "notRedoneOne": "{{waitingOn}} hat dies seit {{days}} Tag nicht nachgebessert. Haken Sie nach oder weisen Sie es neu zu.",
    "notRedone": "{{waitingOn}} hat dies seit {{days}} Tagen nicht nachgebessert. Haken Sie nach oder weisen Sie es neu zu.",
    "inviteNotAcceptedOne": "{{waitingOn}} hat die Einladung seit {{days}} Tag nicht angenommen. Senden Sie sie erneut oder ziehen Sie sie zurück.",
    "inviteNotAccepted": "{{waitingOn}} hat die Einladung seit {{days}} Tagen nicht angenommen. Senden Sie sie erneut oder ziehen Sie sie zurück.",
    "approvedNoWorkOne": "Vor {{days}} Tag genehmigt, aber es wurde noch keine Arbeit angelegt.",
    "approvedNoWork": "Vor {{days}} Tagen genehmigt, aber es wurde noch keine Arbeit angelegt.",
    "overdueOne": "Vor {{days}} Tag fällig und noch nicht erledigt.",
    "overdue": "Vor {{days}} Tagen fällig und noch nicht erledigt.",
    "overdueUnassignedOne": "Vor {{days}} Tag fällig und niemandem zugewiesen. Weisen Sie es zu oder erledigen Sie es selbst.",
    "overdueUnassigned": "Vor {{days}} Tagen fällig und niemandem zugewiesen. Weisen Sie es zu oder erledigen Sie es selbst.",
    "overdueNotDoneOne": "{{waitingOn}} hat es nicht erledigt, obwohl es vor {{days}} Tag fällig war. Weisen Sie es neu zu oder erledigen Sie es selbst.",
    "overdueNotDone": "{{waitingOn}} hat es nicht erledigt, obwohl es vor {{days}} Tagen fällig war. Weisen Sie es neu zu oder erledigen Sie es selbst.",
    "quotesStalledOne": "Bei diesen Angeboten hat sich seit {{days}} Tag nichts getan. Nehmen Sie eines an, haken Sie nach oder setzen Sie eine Frist.",
    "quotesStalled": "Bei diesen Angeboten hat sich seit {{days}} Tagen nichts getan. Nehmen Sie eines an, haken Sie nach oder setzen Sie eine Frist.",
    "awaitingYourValidationOne": "Wartet seit {{days}} Tag auf Ihre Validierung.",
    "awaitingYourValidation": "Wartet seit {{days}} Tagen auf Ihre Validierung.",
    "quoteDeadlinePassedOne": "Die Angebotsfrist ist vor {{days}} Tag abgelaufen. Nehmen Sie eines an, haken Sie nach oder setzen Sie ein neues Datum.",
    "quoteDeadlinePassed": "Die Angebotsfrist ist vor {{days}} Tagen abgelaufen. Nehmen Sie eines an, haken Sie nach oder setzen Sie ein neues Datum.",
    "awaitingYourPickupOne": "Wartet seit {{days}} Tag darauf, dass Sie es übernehmen.",
    "awaitingYourPickup": "Wartet seit {{days}} Tagen darauf, dass Sie es übernehmen.",
    "awaitingYourApprovalOne": "Wartet seit {{days}} Tag auf Ihre Freigabe.",
    "awaitingYourApproval": "Wartet seit {{days}} Tagen auf Ihre Freigabe.",
    "noResponseOne": "{{waitingOn}}: seit {{days}} Tag keine Antwort.",
    "noResponse": "{{waitingOn}}: seit {{days}} Tagen keine Antwort.",
    "notValidatedOne": "{{waitingOn}} hat dies seit {{days}} Tag nicht validiert.",
    "notValidated": "{{waitingOn}} hat dies seit {{days}} Tagen nicht validiert.",
    "inviteNotAnsweredOne": "{{waitingOn}} hat seit {{days}} Tag nicht auf die Einladung geantwortet. Haken Sie nach oder weisen Sie jemand anderen zu.",
    "inviteNotAnswered": "{{waitingOn}} hat seit {{days}} Tagen nicht auf die Einladung geantwortet. Haken Sie nach oder weisen Sie jemand anderen zu.",
    "notRepliedOne": "{{waitingOn}} hat seit {{days}} Tag nicht geantwortet.",
    "notReplied": "{{waitingOn}} hat seit {{days}} Tagen nicht geantwortet.",
    "notApprovedOne": "{{waitingOn}} hat dies seit {{days}} Tag nicht freigegeben.",
    "notApproved": "{{waitingOn}} hat dies seit {{days}} Tagen nicht freigegeben."
  },
  "values": {
    "featureStatus": {
      "under_review": "in Prüfung",
      "planned": "geplant",
      "in_progress": "in Entwicklung",
      "shipped": "jetzt in der App",
      "not_planned": "vorerst nicht geplant",
      "considering": "in Überlegung"
    },
    "reason": {
      "fault": "Defekt",
      "end_of_life": "Ende der Nutzungsdauer",
      "replaced": "ersetzt",
      "seasonal": "saisonal",
      "relocated": "verlegt",
      "decommissioned": "stillgelegt",
      "sold": "verkauft",
      "disposed": "entsorgt",
      "lost": "verloren",
      "other": "sonstiger Grund"
    },
    "period": {
      "am": "vormittags",
      "pm": "nachmittags"
    },
    "periodLabel": {
      "morning": "vormittags",
      "afternoon": "nachmittags"
    },
    "documentType": {
      "certificate": "dieses Zertifikat",
      "warranty": "diese Garantie",
      "compliance_document": "dieses Konformitätsdokument",
      "document": "dieses Dokument"
    },
    "role": {
      "owner": "Inhaber",
      "admin": "Admin",
      "member": "Mitglied"
    },
    "action": {
      "skip": "Überspringen",
      "reschedule": "Neu planen",
      "reassign": "Neu zuweisen"
    },
    "itemTitle": {
      "inspection": "Inspektion",
      "job": "Auftrag",
      "document": "Dokument",
      "request": "Anfrage",
      "scheduled_inspection": "Geplante Inspektion",
      "invitation_to_the_team": "Einladung ins Team"
    },
    "waitingOn": {
      "the_recipient": "Die empfangende Person",
      "asset_approver": "Genehmigende Person für die Anlage",
      "the_approver": "Die genehmigende Person",
      "the_requester": "Die anfragende Person",
      "the_assignee": "Die zuständige Person",
      "the_validator": "Die validierende Person",
      "the_team": "Das Team",
      "the_contractors_you_asked": "Die angefragten Auftragnehmer",
      "the_contractor": "Der Auftragnehmer",
      "the_invitee": "Die eingeladene Person",
      "nobody": "Niemand",
      "The_recipient": "Die empfangende Person",
      "The_approver": "Die genehmigende Person",
      "The_requester": "Die anfragende Person",
      "The_assignee": "Die zuständige Person",
      "The_validator": "Die validierende Person",
      "The_team": "Das Team",
      "The_contractor": "Der Auftragnehmer",
      "The_invitee": "Die eingeladene Person"
    }
  }
};
